import * as i0 from '@angular/core';
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var AuxiliaryDataFieldType = /*#__PURE__*/function (AuxiliaryDataFieldType) {
  AuxiliaryDataFieldType[AuxiliaryDataFieldType["AUXILIARY_DATA_FIELD_TYPE_INVALID"] = 0] = "AUXILIARY_DATA_FIELD_TYPE_INVALID";
  AuxiliaryDataFieldType[AuxiliaryDataFieldType["AUXILIARY_DATA_FIELD_TYPE_STRING"] = 1] = "AUXILIARY_DATA_FIELD_TYPE_STRING";
  AuxiliaryDataFieldType[AuxiliaryDataFieldType["AUXILIARY_DATA_FIELD_TYPE_INTEGER"] = 2] = "AUXILIARY_DATA_FIELD_TYPE_INTEGER";
  AuxiliaryDataFieldType[AuxiliaryDataFieldType["AUXILIARY_DATA_FIELD_TYPE_DATE"] = 3] = "AUXILIARY_DATA_FIELD_TYPE_DATE";
  AuxiliaryDataFieldType[AuxiliaryDataFieldType["AUXILIARY_DATA_FIELD_TYPE_DROPDOWN"] = 4] = "AUXILIARY_DATA_FIELD_TYPE_DROPDOWN";
  AuxiliaryDataFieldType[AuxiliaryDataFieldType["AUXILIARY_DATA_FIELD_TYPE_CURRENCY"] = 5] = "AUXILIARY_DATA_FIELD_TYPE_CURRENCY";
  return AuxiliaryDataFieldType;
}(AuxiliaryDataFieldType || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums.
// *********************************
var LookupRequestAccountFilterOperator = /*#__PURE__*/function (LookupRequestAccountFilterOperator) {
  LookupRequestAccountFilterOperator[LookupRequestAccountFilterOperator["UNSET"] = 0] = "UNSET";
  LookupRequestAccountFilterOperator[LookupRequestAccountFilterOperator["OR"] = 1] = "OR";
  LookupRequestAccountFilterOperator[LookupRequestAccountFilterOperator["AND"] = 2] = "AND";
  return LookupRequestAccountFilterOperator;
}(LookupRequestAccountFilterOperator || {});
var LookupRequestAccountStatus = /*#__PURE__*/function (LookupRequestAccountStatus) {
  LookupRequestAccountStatus[LookupRequestAccountStatus["Enabled"] = 0] = "Enabled";
  LookupRequestAccountStatus[LookupRequestAccountStatus["Disabled"] = 1] = "Disabled";
  LookupRequestAccountStatus[LookupRequestAccountStatus["Trial"] = 2] = "Trial";
  return LookupRequestAccountStatus;
}(LookupRequestAccountStatus || {});
var ActionListModifyActions = /*#__PURE__*/function (ActionListModifyActions) {
  ActionListModifyActions[ActionListModifyActions["APPEND"] = 0] = "APPEND";
  ActionListModifyActions[ActionListModifyActions["REMOVE"] = 1] = "REMOVE";
  return ActionListModifyActions;
}(ActionListModifyActions || {});
var LookupRequestListingDistributionFilterActivationStatus = /*#__PURE__*/function (LookupRequestListingDistributionFilterActivationStatus) {
  LookupRequestListingDistributionFilterActivationStatus[LookupRequestListingDistributionFilterActivationStatus["ACTIVATION_STATUS_UNSPECIFIED"] = 0] = "ACTIVATION_STATUS_UNSPECIFIED";
  LookupRequestListingDistributionFilterActivationStatus[LookupRequestListingDistributionFilterActivationStatus["ACTIVATION_STATUS_ACTIVE"] = 1] = "ACTIVATION_STATUS_ACTIVE";
  LookupRequestListingDistributionFilterActivationStatus[LookupRequestListingDistributionFilterActivationStatus["ACTIVATION_STATUS_INACTIVE"] = 2] = "ACTIVATION_STATUS_INACTIVE";
  LookupRequestListingDistributionFilterActivationStatus[LookupRequestListingDistributionFilterActivationStatus["ACTIVATION_STATUS_EXPIRED"] = 3] = "ACTIVATION_STATUS_EXPIRED";
  return LookupRequestListingDistributionFilterActivationStatus;
}(LookupRequestListingDistributionFilterActivationStatus || {});
var AggregationSupportedFields = /*#__PURE__*/function (AggregationSupportedFields) {
  AggregationSupportedFields[AggregationSupportedFields["AGGREGATION_UNSPECIFIED"] = 0] = "AGGREGATION_UNSPECIFIED";
  AggregationSupportedFields[AggregationSupportedFields["AGGREGATION_TAGS"] = 1] = "AGGREGATION_TAGS";
  AggregationSupportedFields[AggregationSupportedFields["AGGREGATION_MARKETING_INFO_CONVERSION_POINT"] = 2] = "AGGREGATION_MARKETING_INFO_CONVERSION_POINT";
  return AggregationSupportedFields;
}(AggregationSupportedFields || {});
var LookupRequestListingDistributionFilterAutoRenew = /*#__PURE__*/function (LookupRequestListingDistributionFilterAutoRenew) {
  LookupRequestListingDistributionFilterAutoRenew[LookupRequestListingDistributionFilterAutoRenew["AUTO_RENEW_UNSPECIFIED"] = 0] = "AUTO_RENEW_UNSPECIFIED";
  LookupRequestListingDistributionFilterAutoRenew[LookupRequestListingDistributionFilterAutoRenew["AUTO_RENEW_ENABLED"] = 1] = "AUTO_RENEW_ENABLED";
  LookupRequestListingDistributionFilterAutoRenew[LookupRequestListingDistributionFilterAutoRenew["AUTO_RENEW_DISABLED"] = 2] = "AUTO_RENEW_DISABLED";
  return LookupRequestListingDistributionFilterAutoRenew;
}(LookupRequestListingDistributionFilterAutoRenew || {});
var AuxiliaryDataSearchDateOperation = /*#__PURE__*/function (AuxiliaryDataSearchDateOperation) {
  AuxiliaryDataSearchDateOperation[AuxiliaryDataSearchDateOperation["DATE_UNDEFINED"] = 0] = "DATE_UNDEFINED";
  AuxiliaryDataSearchDateOperation[AuxiliaryDataSearchDateOperation["DATE_RANGE"] = 1] = "DATE_RANGE";
  return AuxiliaryDataSearchDateOperation;
}(AuxiliaryDataSearchDateOperation || {});
var AuxiliaryDataSearchIntegerOperation = /*#__PURE__*/function (AuxiliaryDataSearchIntegerOperation) {
  AuxiliaryDataSearchIntegerOperation[AuxiliaryDataSearchIntegerOperation["INT_UNDEFINED"] = 0] = "INT_UNDEFINED";
  AuxiliaryDataSearchIntegerOperation[AuxiliaryDataSearchIntegerOperation["INT_RANGE"] = 1] = "INT_RANGE";
  return AuxiliaryDataSearchIntegerOperation;
}(AuxiliaryDataSearchIntegerOperation || {});
var AuxiliaryDataSearchStringOperation = /*#__PURE__*/function (AuxiliaryDataSearchStringOperation) {
  AuxiliaryDataSearchStringOperation[AuxiliaryDataSearchStringOperation["STRING_UNDEFINED"] = 0] = "STRING_UNDEFINED";
  AuxiliaryDataSearchStringOperation[AuxiliaryDataSearchStringOperation["STRING_EQUALS"] = 1] = "STRING_EQUALS";
  AuxiliaryDataSearchStringOperation[AuxiliaryDataSearchStringOperation["STRING_DOES_NOT_EQUAL"] = 2] = "STRING_DOES_NOT_EQUAL";
  return AuxiliaryDataSearchStringOperation;
}(AuxiliaryDataSearchStringOperation || {});
var ListingSyncProBillingFrequency = /*#__PURE__*/function (ListingSyncProBillingFrequency) {
  ListingSyncProBillingFrequency[ListingSyncProBillingFrequency["MONTHLY"] = 0] = "MONTHLY";
  ListingSyncProBillingFrequency[ListingSyncProBillingFrequency["YEARLY"] = 1] = "YEARLY";
  ListingSyncProBillingFrequency[ListingSyncProBillingFrequency["ONE_TIME"] = 2] = "ONE_TIME";
  return ListingSyncProBillingFrequency;
}(ListingSyncProBillingFrequency || {});
var ClosedStatus = /*#__PURE__*/function (ClosedStatus) {
  ClosedStatus[ClosedStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
  ClosedStatus[ClosedStatus["OPEN"] = 1] = "OPEN";
  ClosedStatus[ClosedStatus["LIMITED"] = 2] = "LIMITED";
  ClosedStatus[ClosedStatus["TEMPORARY"] = 3] = "TEMPORARY";
  ClosedStatus[ClosedStatus["PERMANENT"] = 4] = "PERMANENT";
  return ClosedStatus;
}(ClosedStatus || {});
var ContactDetailsForListDuplicatesCriteriaMatchType = /*#__PURE__*/function (ContactDetailsForListDuplicatesCriteriaMatchType) {
  ContactDetailsForListDuplicatesCriteriaMatchType[ContactDetailsForListDuplicatesCriteriaMatchType["CRITERIA_MATCH_TYPE_UNKNOWN"] = 0] = "CRITERIA_MATCH_TYPE_UNKNOWN";
  ContactDetailsForListDuplicatesCriteriaMatchType[ContactDetailsForListDuplicatesCriteriaMatchType["CRITERIA_MATCH_TYPE_PHONE_NUMBER"] = 1] = "CRITERIA_MATCH_TYPE_PHONE_NUMBER";
  ContactDetailsForListDuplicatesCriteriaMatchType[ContactDetailsForListDuplicatesCriteriaMatchType["CRITERIA_MATCH_TYPE_EMAIL"] = 2] = "CRITERIA_MATCH_TYPE_EMAIL";
  ContactDetailsForListDuplicatesCriteriaMatchType[ContactDetailsForListDuplicatesCriteriaMatchType["CRITERIA_MATCH_TYPE_PHONE_NUMBER_AND_EMAIL"] = 3] = "CRITERIA_MATCH_TYPE_PHONE_NUMBER_AND_EMAIL";
  ContactDetailsForListDuplicatesCriteriaMatchType[ContactDetailsForListDuplicatesCriteriaMatchType["CRITERIA_MATCH_TYPE_PHONENUMBER_OR_EMAIL"] = 4] = "CRITERIA_MATCH_TYPE_PHONENUMBER_OR_EMAIL";
  return ContactDetailsForListDuplicatesCriteriaMatchType;
}(ContactDetailsForListDuplicatesCriteriaMatchType || {});
var EstimatedAnnualRevenue = /*#__PURE__*/function (EstimatedAnnualRevenue) {
  EstimatedAnnualRevenue[EstimatedAnnualRevenue["ESTIMATED_ANNUAL_REVENUE_UNSPECIFIED"] = 0] = "ESTIMATED_ANNUAL_REVENUE_UNSPECIFIED";
  EstimatedAnnualRevenue[EstimatedAnnualRevenue["ESTIMATED_ANNUAL_REVENUE_0_1M"] = 1] = "ESTIMATED_ANNUAL_REVENUE_0_1M";
  EstimatedAnnualRevenue[EstimatedAnnualRevenue["ESTIMATED_ANNUAL_REVENUE_1M_10M"] = 2] = "ESTIMATED_ANNUAL_REVENUE_1M_10M";
  EstimatedAnnualRevenue[EstimatedAnnualRevenue["ESTIMATED_ANNUAL_REVENUE_10M_50M"] = 3] = "ESTIMATED_ANNUAL_REVENUE_10M_50M";
  EstimatedAnnualRevenue[EstimatedAnnualRevenue["ESTIMATED_ANNUAL_REVENUE_50M_100M"] = 4] = "ESTIMATED_ANNUAL_REVENUE_50M_100M";
  EstimatedAnnualRevenue[EstimatedAnnualRevenue["ESTIMATED_ANNUAL_REVENUE_100M_250M"] = 5] = "ESTIMATED_ANNUAL_REVENUE_100M_250M";
  EstimatedAnnualRevenue[EstimatedAnnualRevenue["ESTIMATED_ANNUAL_REVENUE_250M_500M"] = 6] = "ESTIMATED_ANNUAL_REVENUE_250M_500M";
  EstimatedAnnualRevenue[EstimatedAnnualRevenue["ESTIMATED_ANNUAL_REVENUE_500M_1B"] = 7] = "ESTIMATED_ANNUAL_REVENUE_500M_1B";
  EstimatedAnnualRevenue[EstimatedAnnualRevenue["ESTIMATED_ANNUAL_REVENUE_1B_10B"] = 8] = "ESTIMATED_ANNUAL_REVENUE_1B_10B";
  EstimatedAnnualRevenue[EstimatedAnnualRevenue["ESTIMATED_ANNUAL_REVENUE_10B_OR_MORE"] = 9] = "ESTIMATED_ANNUAL_REVENUE_10B_OR_MORE";
  return EstimatedAnnualRevenue;
}(EstimatedAnnualRevenue || {});
var UpdateAccountWithExternalBusinessDataRequestFields = /*#__PURE__*/function (UpdateAccountWithExternalBusinessDataRequestFields) {
  UpdateAccountWithExternalBusinessDataRequestFields[UpdateAccountWithExternalBusinessDataRequestFields["TAXONOMY"] = 0] = "TAXONOMY";
  UpdateAccountWithExternalBusinessDataRequestFields[UpdateAccountWithExternalBusinessDataRequestFields["NAPW"] = 1] = "NAPW";
  return UpdateAccountWithExternalBusinessDataRequestFields;
}(UpdateAccountWithExternalBusinessDataRequestFields || {});
var HealthCareProfessionalInformationGender = /*#__PURE__*/function (HealthCareProfessionalInformationGender) {
  HealthCareProfessionalInformationGender[HealthCareProfessionalInformationGender["NotSpecified"] = 0] = "NotSpecified";
  HealthCareProfessionalInformationGender[HealthCareProfessionalInformationGender["Female"] = 1] = "Female";
  HealthCareProfessionalInformationGender[HealthCareProfessionalInformationGender["Male"] = 2] = "Male";
  HealthCareProfessionalInformationGender[HealthCareProfessionalInformationGender["Other"] = 3] = "Other";
  return HealthCareProfessionalInformationGender;
}(HealthCareProfessionalInformationGender || {});
var InferenceRequestMode = /*#__PURE__*/function (InferenceRequestMode) {
  InferenceRequestMode[InferenceRequestMode["NO_MODE"] = 0] = "NO_MODE";
  InferenceRequestMode[InferenceRequestMode["LIVE"] = 1] = "LIVE";
  InferenceRequestMode[InferenceRequestMode["PRIORITY"] = 2] = "PRIORITY";
  InferenceRequestMode[InferenceRequestMode["STANDARD"] = 3] = "STANDARD";
  return InferenceRequestMode;
}(InferenceRequestMode || {});
var IsAvailable = /*#__PURE__*/function (IsAvailable) {
  IsAvailable[IsAvailable["UNSET"] = 0] = "UNSET";
  IsAvailable[IsAvailable["YES"] = 1] = "YES";
  IsAvailable[IsAvailable["NO"] = 2] = "NO";
  return IsAvailable;
}(IsAvailable || {});
var LifecycleStage = /*#__PURE__*/function (LifecycleStage) {
  LifecycleStage[LifecycleStage["LIFECYCLE_STAGE_UNSET"] = 0] = "LIFECYCLE_STAGE_UNSET";
  LifecycleStage[LifecycleStage["LIFECYCLE_STAGE_LEAD"] = 1] = "LIFECYCLE_STAGE_LEAD";
  LifecycleStage[LifecycleStage["LIFECYCLE_STAGE_PROSPECT"] = 2] = "LIFECYCLE_STAGE_PROSPECT";
  LifecycleStage[LifecycleStage["LIFECYCLE_STAGE_CUSTOMER"] = 3] = "LIFECYCLE_STAGE_CUSTOMER";
  return LifecycleStage;
}(LifecycleStage || {});
var MarketingClassification = /*#__PURE__*/function (MarketingClassification) {
  MarketingClassification[MarketingClassification["MARKETING_CLASSIFICATION_UNUSED"] = 0] = "MARKETING_CLASSIFICATION_UNUSED";
  MarketingClassification[MarketingClassification["MARKETING_CLASSIFICATION_SMB"] = 1] = "MARKETING_CLASSIFICATION_SMB";
  MarketingClassification[MarketingClassification["MARKETING_CLASSIFICATION_SPAM"] = 2] = "MARKETING_CLASSIFICATION_SPAM";
  MarketingClassification[MarketingClassification["MARKETING_CLASSIFICATION_DUPLICATE"] = 3] = "MARKETING_CLASSIFICATION_DUPLICATE";
  MarketingClassification[MarketingClassification["MARKETING_CLASSIFICATION_BLACKLISTED"] = 4] = "MARKETING_CLASSIFICATION_BLACKLISTED";
  MarketingClassification[MarketingClassification["MARKETING_CLASSIFICATION_OUT_OF_MARKET"] = 5] = "MARKETING_CLASSIFICATION_OUT_OF_MARKET";
  return MarketingClassification;
}(MarketingClassification || {});
var RichDataPaymentMethods = /*#__PURE__*/function (RichDataPaymentMethods) {
  RichDataPaymentMethods[RichDataPaymentMethods["AMERICAN_EXPRESS"] = 0] = "AMERICAN_EXPRESS";
  RichDataPaymentMethods[RichDataPaymentMethods["ANDROID_PAY"] = 1] = "ANDROID_PAY";
  RichDataPaymentMethods[RichDataPaymentMethods["APPLE_PAY"] = 2] = "APPLE_PAY";
  RichDataPaymentMethods[RichDataPaymentMethods["CASH"] = 3] = "CASH";
  RichDataPaymentMethods[RichDataPaymentMethods["CHECK"] = 4] = "CHECK";
  RichDataPaymentMethods[RichDataPaymentMethods["DEBIT"] = 5] = "DEBIT";
  RichDataPaymentMethods[RichDataPaymentMethods["DINERS_CLUB"] = 6] = "DINERS_CLUB";
  RichDataPaymentMethods[RichDataPaymentMethods["DISCOVER"] = 7] = "DISCOVER";
  RichDataPaymentMethods[RichDataPaymentMethods["MASTERCARD"] = 8] = "MASTERCARD";
  RichDataPaymentMethods[RichDataPaymentMethods["PAYPAL"] = 9] = "PAYPAL";
  RichDataPaymentMethods[RichDataPaymentMethods["SAMSUNG_PAY"] = 10] = "SAMSUNG_PAY";
  RichDataPaymentMethods[RichDataPaymentMethods["STORE_CARD"] = 11] = "STORE_CARD";
  RichDataPaymentMethods[RichDataPaymentMethods["TRAVELERS_CHECK"] = 12] = "TRAVELERS_CHECK";
  RichDataPaymentMethods[RichDataPaymentMethods["VISA"] = 13] = "VISA";
  RichDataPaymentMethods[RichDataPaymentMethods["CCS"] = 14] = "CCS";
  RichDataPaymentMethods[RichDataPaymentMethods["SODEXO"] = 15] = "SODEXO";
  RichDataPaymentMethods[RichDataPaymentMethods["GOPAY"] = 16] = "GOPAY";
  RichDataPaymentMethods[RichDataPaymentMethods["V_PAY"] = 17] = "V_PAY";
  RichDataPaymentMethods[RichDataPaymentMethods["FINANCING"] = 18] = "FINANCING";
  RichDataPaymentMethods[RichDataPaymentMethods["INVOICE"] = 19] = "INVOICE";
  RichDataPaymentMethods[RichDataPaymentMethods["PAYSEC"] = 20] = "PAYSEC";
  RichDataPaymentMethods[RichDataPaymentMethods["BITCOIN"] = 21] = "BITCOIN";
  return RichDataPaymentMethods;
}(RichDataPaymentMethods || {});
var LookupRequestPresence = /*#__PURE__*/function (LookupRequestPresence) {
  LookupRequestPresence[LookupRequestPresence["Any"] = 0] = "Any";
  LookupRequestPresence[LookupRequestPresence["Present"] = 1] = "Present";
  LookupRequestPresence[LookupRequestPresence["Absent"] = 2] = "Absent";
  return LookupRequestPresence;
}(LookupRequestPresence || {});
var SearchCategoryMigrationRequestReviewStatus = /*#__PURE__*/function (SearchCategoryMigrationRequestReviewStatus) {
  SearchCategoryMigrationRequestReviewStatus[SearchCategoryMigrationRequestReviewStatus["UNSET"] = 0] = "UNSET";
  SearchCategoryMigrationRequestReviewStatus[SearchCategoryMigrationRequestReviewStatus["UNDER_REVIEW"] = 1] = "UNDER_REVIEW";
  SearchCategoryMigrationRequestReviewStatus[SearchCategoryMigrationRequestReviewStatus["REVIEWED"] = 2] = "REVIEWED";
  return SearchCategoryMigrationRequestReviewStatus;
}(SearchCategoryMigrationRequestReviewStatus || {});
var SearchableField = /*#__PURE__*/function (SearchableField) {
  SearchableField[SearchableField["SEARCHABLE_FIELD_UNSPECIFIED"] = 0] = "SEARCHABLE_FIELD_UNSPECIFIED";
  SearchableField[SearchableField["SEARCHABLE_FIELD_COMPANY_NAME"] = 1] = "SEARCHABLE_FIELD_COMPANY_NAME";
  SearchableField[SearchableField["SEARCHABLE_FIELD_COMMON_NAME"] = 2] = "SEARCHABLE_FIELD_COMMON_NAME";
  SearchableField[SearchableField["SEARCHABLE_FIELD_ADDRESS"] = 3] = "SEARCHABLE_FIELD_ADDRESS";
  SearchableField[SearchableField["SEARCHABLE_FIELD_ADDRESS_2"] = 4] = "SEARCHABLE_FIELD_ADDRESS_2";
  SearchableField[SearchableField["SEARCHABLE_FIELD_CITY"] = 5] = "SEARCHABLE_FIELD_CITY";
  SearchableField[SearchableField["SEARCHABLE_FIELD_STATE"] = 6] = "SEARCHABLE_FIELD_STATE";
  SearchableField[SearchableField["SEARCHABLE_FIELD_ZIP"] = 7] = "SEARCHABLE_FIELD_ZIP";
  SearchableField[SearchableField["SEARCHABLE_FIELD_COUNTRY"] = 8] = "SEARCHABLE_FIELD_COUNTRY";
  SearchableField[SearchableField["SEARCHABLE_FIELD_WORK_NUMBER"] = 9] = "SEARCHABLE_FIELD_WORK_NUMBER";
  SearchableField[SearchableField["SEARCHABLE_FIELD_SOCIAL_PROFILE_ID"] = 10] = "SEARCHABLE_FIELD_SOCIAL_PROFILE_ID";
  SearchableField[SearchableField["SEARCHABLE_FIELD_CUSTOMER_ID"] = 11] = "SEARCHABLE_FIELD_CUSTOMER_ID";
  SearchableField[SearchableField["SEARCHABLE_FIELD_ACCOUNT_GROUP_ID"] = 12] = "SEARCHABLE_FIELD_ACCOUNT_GROUP_ID";
  return SearchableField;
}(SearchableField || {});
var ServiceAreaBusinessType = /*#__PURE__*/function (ServiceAreaBusinessType) {
  ServiceAreaBusinessType[ServiceAreaBusinessType["SERVICE_AREA_BUSINESS_TYPE_UNSPECIFIED"] = 0] = "SERVICE_AREA_BUSINESS_TYPE_UNSPECIFIED";
  ServiceAreaBusinessType[ServiceAreaBusinessType["SERVICE_AREA_BUSINESS_TYPE_CUSTOMER_LOCATION_ONLY"] = 1] = "SERVICE_AREA_BUSINESS_TYPE_CUSTOMER_LOCATION_ONLY";
  ServiceAreaBusinessType[ServiceAreaBusinessType["SERVICE_AREA_BUSINESS_TYPE_CUSTOMER_AND_BUSINESS_LOCATION"] = 2] = "SERVICE_AREA_BUSINESS_TYPE_CUSTOMER_AND_BUSINESS_LOCATION";
  return ServiceAreaBusinessType;
}(ServiceAreaBusinessType || {});
var ListingSyncProServiceProviders = /*#__PURE__*/function (ListingSyncProServiceProviders) {
  ListingSyncProServiceProviders[ListingSyncProServiceProviders["UBERALL"] = 0] = "UBERALL";
  ListingSyncProServiceProviders[ListingSyncProServiceProviders["YEXT"] = 1] = "YEXT";
  return ListingSyncProServiceProviders;
}(ListingSyncProServiceProviders || {});
var SortDirection = /*#__PURE__*/function (SortDirection) {
  SortDirection[SortDirection["Ascending"] = 0] = "Ascending";
  SortDirection[SortDirection["Descending"] = 1] = "Descending";
  return SortDirection;
}(SortDirection || {});
var SortField = /*#__PURE__*/function (SortField) {
  SortField[SortField["Modified"] = 0] = "Modified";
  SortField[SortField["Created"] = 1] = "Created";
  SortField[SortField["CompanyName"] = 2] = "CompanyName";
  return SortField;
}(SortField || {});
var TaskStatus = /*#__PURE__*/function (TaskStatus) {
  TaskStatus[TaskStatus["INVALID"] = 0] = "INVALID";
  TaskStatus[TaskStatus["COMPLETED"] = 1] = "COMPLETED";
  TaskStatus[TaskStatus["IN_PROGRESS"] = 2] = "IN_PROGRESS";
  TaskStatus[TaskStatus["FAILED"] = 3] = "FAILED";
  return TaskStatus;
}(TaskStatus || {});
// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Enums Index.
// *********************************

function enumStringToValue$7(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Access {
  static fromProto(proto) {
    let m = new Access();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.scope !== 'undefined') {
      toReturn['scope'] = this.scope;
    }
    if (typeof this.public !== 'undefined') {
      toReturn['public'] = this.public;
    }
    return toReturn;
  }
}
function enumStringToValue$6(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class MethodMetadata {
  static fromProto(proto) {
    let m = new MethodMetadata();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.isPublic !== 'undefined') {
      toReturn['isPublic'] = this.isPublic;
    }
    if (typeof this.scopes !== 'undefined') {
      toReturn['scopes'] = this.scopes;
    }
    return toReturn;
  }
}
class SDKMetadata {
  static fromProto(proto) {
    let m = new SDKMetadata();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.sdkName !== 'undefined') {
      toReturn['sdkName'] = this.sdkName;
    }
    return toReturn;
  }
}
function enumStringToValue$5(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class FieldMask {
  static fromProto(proto) {
    let m = new FieldMask();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.paths !== 'undefined') {
      toReturn['paths'] = this.paths;
    }
    return toReturn;
  }
}
function enumStringToValue$4(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class PagedRequestOptions {
  static fromProto(proto) {
    let m = new PagedRequestOptions();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class PagedResponseMetadata {
  static fromProto(proto) {
    let m = new PagedResponseMetadata();
    m = Object.assign(m, proto);
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
function enumStringToValue$3(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class AddressInfo {
  static fromProto(proto) {
    let m = new AddressInfo();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.address2 !== 'undefined') {
      toReturn['address2'] = this.address2;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.zip !== 'undefined') {
      toReturn['zip'] = this.zip;
    }
    if (typeof this.footnotes !== 'undefined') {
      toReturn['footnotes'] = this.footnotes;
    }
    return toReturn;
  }
}
class AddressValidationResult {
  static fromProto(proto) {
    let m = new AddressValidationResult();
    m = Object.assign(m, proto);
    if (proto.currentAddress) {
      m.currentAddress = AddressInfo.fromProto(proto.currentAddress);
    }
    if (proto.suggestedAddresses) {
      m.suggestedAddresses = proto.suggestedAddresses.map(AddressInfo.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.businessName !== 'undefined') {
      toReturn['businessName'] = this.businessName;
    }
    if (typeof this.currentAddress !== 'undefined' && this.currentAddress !== null) {
      toReturn['currentAddress'] = 'toApiJson' in this.currentAddress ? this.currentAddress.toApiJson() : this.currentAddress;
    }
    if (typeof this.suggestedAddresses !== 'undefined' && this.suggestedAddresses !== null) {
      toReturn['suggestedAddresses'] = 'toApiJson' in this.suggestedAddresses ? this.suggestedAddresses.toApiJson() : this.suggestedAddresses;
    }
    if (typeof this.addressErrors !== 'undefined') {
      toReturn['addressErrors'] = this.addressErrors;
    }
    return toReturn;
  }
}
class ValidateAddressMultiRequest {
  static fromProto(proto) {
    let m = new ValidateAddressMultiRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessIds !== 'undefined') {
      toReturn['businessIds'] = this.businessIds;
    }
    return toReturn;
  }
}
class ValidateAddressMultiResponse {
  static fromProto(proto) {
    let m = new ValidateAddressMultiResponse();
    m = Object.assign(m, proto);
    if (proto.results) {
      m.results = proto.results.map(AddressValidationResult.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.results !== 'undefined' && this.results !== null) {
      toReturn['results'] = 'toApiJson' in this.results ? this.results.toApiJson() : this.results;
    }
    return toReturn;
  }
}
function enumStringToValue$2(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Competitor {
  static fromProto(proto) {
    let m = new Competitor();
    m = Object.assign(m, proto);
    if (proto.location) {
      m.location = Location.fromProto(proto.location);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.competitorId !== 'undefined') {
      toReturn['competitorId'] = this.competitorId;
    }
    if (typeof this.location !== 'undefined' && this.location !== null) {
      toReturn['location'] = 'toApiJson' in this.location ? this.location.toApiJson() : this.location;
    }
    return toReturn;
  }
}
class CreateCompetitorRequest {
  static fromProto(proto) {
    let m = new CreateCompetitorRequest();
    m = Object.assign(m, proto);
    if (proto.location) {
      m.location = Location.fromProto(proto.location);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.location !== 'undefined' && this.location !== null) {
      toReturn['location'] = 'toApiJson' in this.location ? this.location.toApiJson() : this.location;
    }
    return toReturn;
  }
}
class CreateCompetitorResponse {
  static fromProto(proto) {
    let m = new CreateCompetitorResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.competitorId !== 'undefined') {
      toReturn['competitorId'] = this.competitorId;
    }
    return toReturn;
  }
}
class DeleteCompetitorRequest {
  static fromProto(proto) {
    let m = new DeleteCompetitorRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.competitorId !== 'undefined') {
      toReturn['competitorId'] = this.competitorId;
    }
    return toReturn;
  }
}
class GetCompetitorsRequest {
  static fromProto(proto) {
    let m = new GetCompetitorsRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessId !== 'undefined') {
      toReturn['businessId'] = this.businessId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class GetCompetitorsResponse {
  static fromProto(proto) {
    let m = new GetCompetitorsResponse();
    m = Object.assign(m, proto);
    if (proto.competitors) {
      m.competitors = proto.competitors.map(Competitor.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.competitors !== 'undefined' && this.competitors !== null) {
      toReturn['competitors'] = 'toApiJson' in this.competitors ? this.competitors.toApiJson() : this.competitors;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class Location {
  static fromProto(proto) {
    let m = new Location();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.placeId !== 'undefined') {
      toReturn['placeId'] = this.placeId;
    }
    return toReturn;
  }
}
class UpdateCompetitorRequest {
  static fromProto(proto) {
    let m = new UpdateCompetitorRequest();
    m = Object.assign(m, proto);
    if (proto.competitor) {
      m.competitor = Competitor.fromProto(proto.competitor);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.competitor !== 'undefined' && this.competitor !== null) {
      toReturn['competitor'] = 'toApiJson' in this.competitor ? this.competitor.toApiJson() : this.competitor;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
function enumStringToValue$1(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class ArchiveAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new ArchiveAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.identifier) {
      m.identifier = FieldSchemaIdentifier.fromProto(proto.identifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifier !== 'undefined' && this.identifier !== null) {
      toReturn['identifier'] = 'toApiJson' in this.identifier ? this.identifier.toApiJson() : this.identifier;
    }
    return toReturn;
  }
}
class AuxiliaryDataFieldSchema {
  static fromProto(proto) {
    let m = new AuxiliaryDataFieldSchema();
    m = Object.assign(m, proto);
    if (proto.fieldType) {
      m.fieldType = enumStringToValue$1(AuxiliaryDataFieldType, proto.fieldType);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.dropdownOptions) {
      m.dropdownOptions = proto.dropdownOptions.map(DropdownOption.fromProto);
    }
    if (proto.archived) {
      m.archived = new Date(proto.archived);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.fieldType !== 'undefined') {
      toReturn['fieldType'] = this.fieldType;
    }
    if (typeof this.fieldName !== 'undefined') {
      toReturn['fieldName'] = this.fieldName;
    }
    if (typeof this.fieldDescription !== 'undefined') {
      toReturn['fieldDescription'] = this.fieldDescription;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.dropdownOptions !== 'undefined' && this.dropdownOptions !== null) {
      toReturn['dropdownOptions'] = 'toApiJson' in this.dropdownOptions ? this.dropdownOptions.toApiJson() : this.dropdownOptions;
    }
    if (typeof this.currencyCode !== 'undefined') {
      toReturn['currencyCode'] = this.currencyCode;
    }
    if (typeof this.archived !== 'undefined' && this.archived !== null) {
      toReturn['archived'] = 'toApiJson' in this.archived ? this.archived.toApiJson() : this.archived;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    return toReturn;
  }
}
class AuxiliaryDataObjectID {
  static fromProto(proto) {
    let m = new AuxiliaryDataObjectID();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.objectId !== 'undefined') {
      toReturn['objectId'] = this.objectId;
    }
    return toReturn;
  }
}
class CreateAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new CreateAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.fieldSchema) {
      m.fieldSchema = AuxiliaryDataFieldSchema.fromProto(proto.fieldSchema);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldSchema !== 'undefined' && this.fieldSchema !== null) {
      toReturn['fieldSchema'] = 'toApiJson' in this.fieldSchema ? this.fieldSchema.toApiJson() : this.fieldSchema;
    }
    return toReturn;
  }
}
class DropdownOption {
  static fromProto(proto) {
    let m = new DropdownOption();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class FieldDataUpsertOperation {
  static fromProto(proto) {
    let m = new FieldDataUpsertOperation();
    m = Object.assign(m, proto);
    if (proto.integer) {
      m.integer = parseInt(proto.integer, 10);
    }
    if (proto.date) {
      m.date = new Date(proto.date);
    }
    if (proto.currencyValue) {
      m.currencyValue = parseInt(proto.currencyValue, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldDataId !== 'undefined') {
      toReturn['fieldDataId'] = this.fieldDataId;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.integer !== 'undefined') {
      toReturn['integer'] = this.integer;
    }
    if (typeof this.string !== 'undefined') {
      toReturn['string'] = this.string;
    }
    if (typeof this.date !== 'undefined' && this.date !== null) {
      toReturn['date'] = 'toApiJson' in this.date ? this.date.toApiJson() : this.date;
    }
    if (typeof this.dropdownValue !== 'undefined') {
      toReturn['dropdownValue'] = this.dropdownValue;
    }
    if (typeof this.currencyValue !== 'undefined') {
      toReturn['currencyValue'] = this.currencyValue;
    }
    if (typeof this.deleteValue !== 'undefined') {
      toReturn['deleteValue'] = this.deleteValue;
    }
    return toReturn;
  }
}
class FieldSchemaIdentifier {
  static fromProto(proto) {
    let m = new FieldSchemaIdentifier();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ListAuxiliaryDataFieldSchemaRequestFilters {
  static fromProto(proto) {
    let m = new ListAuxiliaryDataFieldSchemaRequestFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.onlyArchived !== 'undefined') {
      toReturn['onlyArchived'] = this.onlyArchived;
    }
    return toReturn;
  }
}
class GetAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new GetAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.identifier) {
      m.identifier = FieldSchemaIdentifier.fromProto(proto.identifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifier !== 'undefined' && this.identifier !== null) {
      toReturn['identifier'] = 'toApiJson' in this.identifier ? this.identifier.toApiJson() : this.identifier;
    }
    return toReturn;
  }
}
class GetAuxiliaryDataFieldSchemaResponse {
  static fromProto(proto) {
    let m = new GetAuxiliaryDataFieldSchemaResponse();
    m = Object.assign(m, proto);
    if (proto.fieldSchema) {
      m.fieldSchema = AuxiliaryDataFieldSchema.fromProto(proto.fieldSchema);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldSchema !== 'undefined' && this.fieldSchema !== null) {
      toReturn['fieldSchema'] = 'toApiJson' in this.fieldSchema ? this.fieldSchema.toApiJson() : this.fieldSchema;
    }
    return toReturn;
  }
}
class GetMultiAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new GetMultiAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.identifiers) {
      m.identifiers = proto.identifiers.map(FieldSchemaIdentifier.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifiers !== 'undefined' && this.identifiers !== null) {
      toReturn['identifiers'] = 'toApiJson' in this.identifiers ? this.identifiers.toApiJson() : this.identifiers;
    }
    return toReturn;
  }
}
class GetMultiAuxiliaryDataFieldSchemaResponse {
  static fromProto(proto) {
    let m = new GetMultiAuxiliaryDataFieldSchemaResponse();
    m = Object.assign(m, proto);
    if (proto.fieldSchemas) {
      m.fieldSchemas = proto.fieldSchemas.map(AuxiliaryDataFieldSchema.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldSchemas !== 'undefined' && this.fieldSchemas !== null) {
      toReturn['fieldSchemas'] = 'toApiJson' in this.fieldSchemas ? this.fieldSchemas.toApiJson() : this.fieldSchemas;
    }
    return toReturn;
  }
}
class GetMultiAuxiliaryDataRequest {
  static fromProto(proto) {
    let m = new GetMultiAuxiliaryDataRequest();
    m = Object.assign(m, proto);
    if (proto.auxiliaryDataObjectId) {
      m.auxiliaryDataObjectId = AuxiliaryDataObjectID.fromProto(proto.auxiliaryDataObjectId);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.auxiliaryDataObjectId !== 'undefined' && this.auxiliaryDataObjectId !== null) {
      toReturn['auxiliaryDataObjectId'] = 'toApiJson' in this.auxiliaryDataObjectId ? this.auxiliaryDataObjectId.toApiJson() : this.auxiliaryDataObjectId;
    }
    if (typeof this.fieldIds !== 'undefined') {
      toReturn['fieldIds'] = this.fieldIds;
    }
    return toReturn;
  }
}
class GetMultiAuxiliaryDataResponse {
  static fromProto(proto) {
    let m = new GetMultiAuxiliaryDataResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.jsonSchema !== 'undefined') {
      toReturn['jsonSchema'] = this.jsonSchema;
    }
    if (typeof this.jsonData !== 'undefined') {
      toReturn['jsonData'] = this.jsonData;
    }
    return toReturn;
  }
}
class ListAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new ListAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    if (proto.filters) {
      m.filters = ListAuxiliaryDataFieldSchemaRequestFilters.fromProto(proto.filters);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    return toReturn;
  }
}
class ListAuxiliaryDataFieldSchemaResponse {
  static fromProto(proto) {
    let m = new ListAuxiliaryDataFieldSchemaResponse();
    m = Object.assign(m, proto);
    if (proto.fieldSchemas) {
      m.fieldSchemas = proto.fieldSchemas.map(AuxiliaryDataFieldSchema.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldSchemas !== 'undefined' && this.fieldSchemas !== null) {
      toReturn['fieldSchemas'] = 'toApiJson' in this.fieldSchemas ? this.fieldSchemas.toApiJson() : this.fieldSchemas;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class ListAuxiliaryDataRequest {
  static fromProto(proto) {
    let m = new ListAuxiliaryDataRequest();
    m = Object.assign(m, proto);
    if (proto.auxiliaryDataObjectId) {
      m.auxiliaryDataObjectId = AuxiliaryDataObjectID.fromProto(proto.auxiliaryDataObjectId);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.auxiliaryDataObjectId !== 'undefined' && this.auxiliaryDataObjectId !== null) {
      toReturn['auxiliaryDataObjectId'] = 'toApiJson' in this.auxiliaryDataObjectId ? this.auxiliaryDataObjectId.toApiJson() : this.auxiliaryDataObjectId;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class ListAuxiliaryDataResponse {
  static fromProto(proto) {
    let m = new ListAuxiliaryDataResponse();
    m = Object.assign(m, proto);
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.jsonSchema !== 'undefined') {
      toReturn['jsonSchema'] = this.jsonSchema;
    }
    if (typeof this.jsonData !== 'undefined') {
      toReturn['jsonData'] = this.jsonData;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class UnarchiveAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new UnarchiveAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.identifier) {
      m.identifier = FieldSchemaIdentifier.fromProto(proto.identifier);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.identifier !== 'undefined' && this.identifier !== null) {
      toReturn['identifier'] = 'toApiJson' in this.identifier ? this.identifier.toApiJson() : this.identifier;
    }
    return toReturn;
  }
}
class UpdateAuxiliaryDataFieldSchemaRequest {
  static fromProto(proto) {
    let m = new UpdateAuxiliaryDataFieldSchemaRequest();
    m = Object.assign(m, proto);
    if (proto.fieldSchema) {
      m.fieldSchema = AuxiliaryDataFieldSchema.fromProto(proto.fieldSchema);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldSchema !== 'undefined' && this.fieldSchema !== null) {
      toReturn['fieldSchema'] = 'toApiJson' in this.fieldSchema ? this.fieldSchema.toApiJson() : this.fieldSchema;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpsertAuxiliaryDataRequest {
  static fromProto(proto) {
    let m = new UpsertAuxiliaryDataRequest();
    m = Object.assign(m, proto);
    if (proto.auxiliaryDataObjectId) {
      m.auxiliaryDataObjectId = AuxiliaryDataObjectID.fromProto(proto.auxiliaryDataObjectId);
    }
    if (proto.fieldDataUpsertOperations) {
      m.fieldDataUpsertOperations = proto.fieldDataUpsertOperations.map(FieldDataUpsertOperation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.auxiliaryDataObjectId !== 'undefined' && this.auxiliaryDataObjectId !== null) {
      toReturn['auxiliaryDataObjectId'] = 'toApiJson' in this.auxiliaryDataObjectId ? this.auxiliaryDataObjectId.toApiJson() : this.auxiliaryDataObjectId;
    }
    if (typeof this.fieldDataUpsertOperations !== 'undefined' && this.fieldDataUpsertOperations !== null) {
      toReturn['fieldDataUpsertOperations'] = 'toApiJson' in this.fieldDataUpsertOperations ? this.fieldDataUpsertOperations.toApiJson() : this.fieldDataUpsertOperations;
    }
    return toReturn;
  }
}
function enumStringToValue(enumRef, value) {
  if (typeof value === 'number') {
    return value;
  }
  return enumRef[value];
}
class Account {
  static fromProto(proto) {
    let m = new Account();
    m = Object.assign(m, proto);
    if (proto.expiry) {
      m.expiry = new Date(proto.expiry);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.isTrial !== 'undefined') {
      toReturn['isTrial'] = this.isTrial;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.marketplaceAppId !== 'undefined') {
      toReturn['marketplaceAppId'] = this.marketplaceAppId;
    }
    if (typeof this.accountId !== 'undefined') {
      toReturn['accountId'] = this.accountId;
    }
    if (typeof this.expiry !== 'undefined' && this.expiry !== null) {
      toReturn['expiry'] = 'toApiJson' in this.expiry ? this.expiry.toApiJson() : this.expiry;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    return toReturn;
  }
}
class LookupRequestAccountFilter {
  static fromProto(proto) {
    let m = new LookupRequestAccountFilter();
    m = Object.assign(m, proto);
    if (proto.accountStatus) {
      m.accountStatus = enumStringToValue(LookupRequestAccountStatus, proto.accountStatus);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.marketplaceAppId !== 'undefined') {
      toReturn['marketplaceAppId'] = this.marketplaceAppId;
    }
    if (typeof this.accountStatus !== 'undefined') {
      toReturn['accountStatus'] = this.accountStatus;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    return toReturn;
  }
}
class AccountGroup {
  static fromProto(proto) {
    let m = new AccountGroup();
    m = Object.assign(m, proto);
    if (proto.deleted) {
      m.deleted = new Date(proto.deleted);
    }
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.updated) {
      m.updated = new Date(proto.updated);
    }
    if (proto.version) {
      m.version = parseInt(proto.version, 10);
    }
    if (proto.accounts) {
      m.accounts = Accounts.fromProto(proto.accounts);
    }
    if (proto.listingDistribution) {
      m.listingDistribution = ListingDistributionDetails.fromProto(proto.listingDistribution);
    }
    if (proto.listingSyncPro) {
      m.listingSyncPro = ListingSyncPro.fromProto(proto.listingSyncPro);
    }
    if (proto.associations) {
      m.associations = proto.associations.map(Association.fromProto);
    }
    if (proto.accountGroupExternalIdentifiers) {
      m.accountGroupExternalIdentifiers = AccountGroupExternalIdentifiers.fromProto(proto.accountGroupExternalIdentifiers);
    }
    if (proto.socialUrls) {
      m.socialUrls = SocialURLs.fromProto(proto.socialUrls);
    }
    if (proto.hoursOfOperation) {
      m.hoursOfOperation = HoursOfOperation.fromProto(proto.hoursOfOperation);
    }
    if (proto.contactDetails) {
      m.contactDetails = ContactDetails.fromProto(proto.contactDetails);
    }
    if (proto.snapshotReports) {
      m.snapshotReports = Snapshots.fromProto(proto.snapshotReports);
    }
    if (proto.legacyProductDetails) {
      m.legacyProductDetails = LegacyProductDetails.fromProto(proto.legacyProductDetails);
    }
    if (proto.richData) {
      m.richData = RichData.fromProto(proto.richData);
    }
    if (proto.napData) {
      m.napData = AccountGroupLocation.fromProto(proto.napData);
    }
    if (proto.status) {
      m.status = Status.fromProto(proto.status);
    }
    if (proto.onBoardingStrategy) {
      m.onBoardingStrategy = OnBoardingStrategy.fromProto(proto.onBoardingStrategy);
    }
    if (proto.health) {
      m.health = AccountGroupHealth.fromProto(proto.health);
    }
    if (proto.constraints) {
      m.constraints = proto.constraints.map(Constraint.fromProto);
    }
    if (proto.additionalCompanyInfo) {
      m.additionalCompanyInfo = AdditionalCompanyInfo.fromProto(proto.additionalCompanyInfo);
    }
    if (proto.marketingInfo) {
      m.marketingInfo = MarketingInfo.fromProto(proto.marketingInfo);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.accountGroupResourceId !== 'undefined') {
      toReturn['accountGroupResourceId'] = this.accountGroupResourceId;
    }
    if (typeof this.deleted !== 'undefined' && this.deleted !== null) {
      toReturn['deleted'] = 'toApiJson' in this.deleted ? this.deleted.toApiJson() : this.deleted;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.updated !== 'undefined' && this.updated !== null) {
      toReturn['updated'] = 'toApiJson' in this.updated ? this.updated.toApiJson() : this.updated;
    }
    if (typeof this.version !== 'undefined') {
      toReturn['version'] = this.version;
    }
    if (typeof this.accounts !== 'undefined' && this.accounts !== null) {
      toReturn['accounts'] = 'toApiJson' in this.accounts ? this.accounts.toApiJson() : this.accounts;
    }
    if (typeof this.listingDistribution !== 'undefined' && this.listingDistribution !== null) {
      toReturn['listingDistribution'] = 'toApiJson' in this.listingDistribution ? this.listingDistribution.toApiJson() : this.listingDistribution;
    }
    if (typeof this.listingSyncPro !== 'undefined' && this.listingSyncPro !== null) {
      toReturn['listingSyncPro'] = 'toApiJson' in this.listingSyncPro ? this.listingSyncPro.toApiJson() : this.listingSyncPro;
    }
    if (typeof this.associations !== 'undefined' && this.associations !== null) {
      toReturn['associations'] = 'toApiJson' in this.associations ? this.associations.toApiJson() : this.associations;
    }
    if (typeof this.accountGroupExternalIdentifiers !== 'undefined' && this.accountGroupExternalIdentifiers !== null) {
      toReturn['accountGroupExternalIdentifiers'] = 'toApiJson' in this.accountGroupExternalIdentifiers ? this.accountGroupExternalIdentifiers.toApiJson() : this.accountGroupExternalIdentifiers;
    }
    if (typeof this.socialUrls !== 'undefined' && this.socialUrls !== null) {
      toReturn['socialUrls'] = 'toApiJson' in this.socialUrls ? this.socialUrls.toApiJson() : this.socialUrls;
    }
    if (typeof this.hoursOfOperation !== 'undefined' && this.hoursOfOperation !== null) {
      toReturn['hoursOfOperation'] = 'toApiJson' in this.hoursOfOperation ? this.hoursOfOperation.toApiJson() : this.hoursOfOperation;
    }
    if (typeof this.contactDetails !== 'undefined' && this.contactDetails !== null) {
      toReturn['contactDetails'] = 'toApiJson' in this.contactDetails ? this.contactDetails.toApiJson() : this.contactDetails;
    }
    if (typeof this.snapshotReports !== 'undefined' && this.snapshotReports !== null) {
      toReturn['snapshotReports'] = 'toApiJson' in this.snapshotReports ? this.snapshotReports.toApiJson() : this.snapshotReports;
    }
    if (typeof this.legacyProductDetails !== 'undefined' && this.legacyProductDetails !== null) {
      toReturn['legacyProductDetails'] = 'toApiJson' in this.legacyProductDetails ? this.legacyProductDetails.toApiJson() : this.legacyProductDetails;
    }
    if (typeof this.richData !== 'undefined' && this.richData !== null) {
      toReturn['richData'] = 'toApiJson' in this.richData ? this.richData.toApiJson() : this.richData;
    }
    if (typeof this.napData !== 'undefined' && this.napData !== null) {
      toReturn['napData'] = 'toApiJson' in this.napData ? this.napData.toApiJson() : this.napData;
    }
    if (typeof this.status !== 'undefined' && this.status !== null) {
      toReturn['status'] = 'toApiJson' in this.status ? this.status.toApiJson() : this.status;
    }
    if (typeof this.onBoardingStrategy !== 'undefined' && this.onBoardingStrategy !== null) {
      toReturn['onBoardingStrategy'] = 'toApiJson' in this.onBoardingStrategy ? this.onBoardingStrategy.toApiJson() : this.onBoardingStrategy;
    }
    if (typeof this.health !== 'undefined' && this.health !== null) {
      toReturn['health'] = 'toApiJson' in this.health ? this.health.toApiJson() : this.health;
    }
    if (typeof this.constraints !== 'undefined' && this.constraints !== null) {
      toReturn['constraints'] = 'toApiJson' in this.constraints ? this.constraints.toApiJson() : this.constraints;
    }
    if (typeof this.additionalCompanyInfo !== 'undefined' && this.additionalCompanyInfo !== null) {
      toReturn['additionalCompanyInfo'] = 'toApiJson' in this.additionalCompanyInfo ? this.additionalCompanyInfo.toApiJson() : this.additionalCompanyInfo;
    }
    if (typeof this.marketingInfo !== 'undefined' && this.marketingInfo !== null) {
      toReturn['marketingInfo'] = 'toApiJson' in this.marketingInfo ? this.marketingInfo.toApiJson() : this.marketingInfo;
    }
    return toReturn;
  }
}
class GetMultiResponseAccountGroupContainer {
  static fromProto(proto) {
    let m = new GetMultiResponseAccountGroupContainer();
    m = Object.assign(m, proto);
    if (proto.accountGroup) {
      m.accountGroup = AccountGroup.fromProto(proto.accountGroup);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroup !== 'undefined' && this.accountGroup !== null) {
      toReturn['accountGroup'] = 'toApiJson' in this.accountGroup ? this.accountGroup.toApiJson() : this.accountGroup;
    }
    return toReturn;
  }
}
class AccountGroupExternalIdentifiers {
  static fromProto(proto) {
    let m = new AccountGroupExternalIdentifiers();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    if (typeof this.jobId !== 'undefined') {
      toReturn['jobId'] = this.jobId;
    }
    if (typeof this.customerIdentifier !== 'undefined') {
      toReturn['customerIdentifier'] = this.customerIdentifier;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.actionLists !== 'undefined') {
      toReturn['actionLists'] = this.actionLists;
    }
    if (typeof this.socialProfileId !== 'undefined') {
      toReturn['socialProfileId'] = this.socialProfileId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    if (typeof this.taxIds !== 'undefined') {
      toReturn['taxIds'] = this.taxIds;
    }
    if (typeof this.salesPersonId !== 'undefined') {
      toReturn['salesPersonId'] = this.salesPersonId;
    }
    if (typeof this.additionalSalesPersonIds !== 'undefined') {
      toReturn['additionalSalesPersonIds'] = this.additionalSalesPersonIds;
    }
    if (typeof this.salesforceId !== 'undefined') {
      toReturn['salesforceId'] = this.salesforceId;
    }
    if (typeof this.vCategoryIds !== 'undefined') {
      toReturn['vCategoryIds'] = this.vCategoryIds;
    }
    if (typeof this.platformCrmCompanyId !== 'undefined') {
      toReturn['platformCrmCompanyId'] = this.platformCrmCompanyId;
    }
    if (typeof this.updateOrigin !== 'undefined') {
      toReturn['updateOrigin'] = this.updateOrigin;
    }
    return toReturn;
  }
}
class AccountGroupHealth {
  static fromProto(proto) {
    let m = new AccountGroupHealth();
    m = Object.assign(m, proto);
    if (proto.updatedOn) {
      m.updatedOn = new Date(proto.updatedOn);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.rating !== 'undefined') {
      toReturn['rating'] = this.rating;
    }
    if (typeof this.reason !== 'undefined') {
      toReturn['reason'] = this.reason;
    }
    if (typeof this.updatedBy !== 'undefined') {
      toReturn['updatedBy'] = this.updatedBy;
    }
    if (typeof this.updatedOn !== 'undefined' && this.updatedOn !== null) {
      toReturn['updatedOn'] = 'toApiJson' in this.updatedOn ? this.updatedOn.toApiJson() : this.updatedOn;
    }
    return toReturn;
  }
}
class UpdateOperationAccountGroupHealthUpdate {
  static fromProto(proto) {
    let m = new UpdateOperationAccountGroupHealthUpdate();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.rating !== 'undefined') {
      toReturn['rating'] = this.rating;
    }
    if (typeof this.reason !== 'undefined') {
      toReturn['reason'] = this.reason;
    }
    return toReturn;
  }
}
class AccountGroupLocation {
  static fromProto(proto) {
    let m = new AccountGroupLocation();
    m = Object.assign(m, proto);
    if (proto.location) {
      m.location = Geo.fromProto(proto.location);
    }
    if (proto.serviceArea) {
      m.serviceArea = ServiceArea.fromProto(proto.serviceArea);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.companyName !== 'undefined') {
      toReturn['companyName'] = this.companyName;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.address2 !== 'undefined') {
      toReturn['address2'] = this.address2;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.zip !== 'undefined') {
      toReturn['zip'] = this.zip;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    if (typeof this.workNumber !== 'undefined') {
      toReturn['workNumber'] = this.workNumber;
    }
    if (typeof this.callTrackingNumber !== 'undefined') {
      toReturn['callTrackingNumber'] = this.callTrackingNumber;
    }
    if (typeof this.location !== 'undefined' && this.location !== null) {
      toReturn['location'] = 'toApiJson' in this.location ? this.location.toApiJson() : this.location;
    }
    if (typeof this.timezone !== 'undefined') {
      toReturn['timezone'] = this.timezone;
    }
    if (typeof this.serviceAreaBusiness !== 'undefined') {
      toReturn['serviceAreaBusiness'] = this.serviceAreaBusiness;
    }
    if (typeof this.serviceArea !== 'undefined' && this.serviceArea !== null) {
      toReturn['serviceArea'] = 'toApiJson' in this.serviceArea ? this.serviceArea.toApiJson() : this.serviceArea;
    }
    return toReturn;
  }
}
class Accounts {
  static fromProto(proto) {
    let m = new Accounts();
    m = Object.assign(m, proto);
    if (proto.accounts) {
      m.accounts = proto.accounts.map(Account.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accounts !== 'undefined' && this.accounts !== null) {
      toReturn['accounts'] = 'toApiJson' in this.accounts ? this.accounts.toApiJson() : this.accounts;
    }
    return toReturn;
  }
}
class ActionListAppend {
  static fromProto(proto) {
    let m = new ActionListAppend();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.actionListName !== 'undefined') {
      toReturn['actionListName'] = this.actionListName;
    }
    return toReturn;
  }
}
class ActionListModify {
  static fromProto(proto) {
    let m = new ActionListModify();
    m = Object.assign(m, proto);
    if (proto.action) {
      m.action = enumStringToValue(ActionListModifyActions, proto.action);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.actionListName !== 'undefined') {
      toReturn['actionListName'] = this.actionListName;
    }
    if (typeof this.action !== 'undefined') {
      toReturn['action'] = this.action;
    }
    return toReturn;
  }
}
class ActivateAccounts {
  static fromProto(proto) {
    let m = new ActivateAccounts();
    m = Object.assign(m, proto);
    if (proto.appKeys) {
      m.appKeys = proto.appKeys.map(AppKey.fromProto);
    }
    if (proto.activations) {
      m.activations = proto.activations.map(Activation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appKeys !== 'undefined' && this.appKeys !== null) {
      toReturn['appKeys'] = 'toApiJson' in this.appKeys ? this.appKeys.toApiJson() : this.appKeys;
    }
    if (typeof this.activations !== 'undefined' && this.activations !== null) {
      toReturn['activations'] = 'toApiJson' in this.activations ? this.activations.toApiJson() : this.activations;
    }
    return toReturn;
  }
}
class Activation {
  static fromProto(proto) {
    let m = new Activation();
    m = Object.assign(m, proto);
    if (proto.appKey) {
      m.appKey = AppKey.fromProto(proto.appKey);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appKey !== 'undefined' && this.appKey !== null) {
      toReturn['appKey'] = 'toApiJson' in this.appKey ? this.appKey.toApiJson() : this.appKey;
    }
    if (typeof this.isTrial !== 'undefined') {
      toReturn['isTrial'] = this.isTrial;
    }
    return toReturn;
  }
}
class AdditionalCompanyInfo {
  static fromProto(proto) {
    let m = new AdditionalCompanyInfo();
    m = Object.assign(m, proto);
    if (proto.estimatedAnnualRevenue) {
      m.estimatedAnnualRevenue = enumStringToValue(EstimatedAnnualRevenue, proto.estimatedAnnualRevenue);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.numEmployees !== 'undefined') {
      toReturn['numEmployees'] = this.numEmployees;
    }
    if (typeof this.estimatedAnnualRevenue !== 'undefined') {
      toReturn['estimatedAnnualRevenue'] = this.estimatedAnnualRevenue;
    }
    return toReturn;
  }
}
class AppKey {
  static fromProto(proto) {
    let m = new AppKey();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.appId !== 'undefined') {
      toReturn['appId'] = this.appId;
    }
    if (typeof this.editionId !== 'undefined') {
      toReturn['editionId'] = this.editionId;
    }
    return toReturn;
  }
}
class Association {
  static fromProto(proto) {
    let m = new Association();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.label !== 'undefined') {
      toReturn['label'] = this.label;
    }
    if (typeof this.productId !== 'undefined') {
      toReturn['productId'] = this.productId;
    }
    if (typeof this.productUserId !== 'undefined') {
      toReturn['productUserId'] = this.productUserId;
    }
    if (typeof this.vbcUserId !== 'undefined') {
      toReturn['vbcUserId'] = this.vbcUserId;
    }
    if (typeof this.defaultLocation !== 'undefined') {
      toReturn['defaultLocation'] = this.defaultLocation;
    }
    return toReturn;
  }
}
class AuxiliaryDataFilter {
  static fromProto(proto) {
    let m = new AuxiliaryDataFilter();
    m = Object.assign(m, proto);
    if (proto.searchFilters) {
      m.searchFilters = proto.searchFilters.map(AuxiliaryDataSearchFilter.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.searchFilters !== 'undefined' && this.searchFilters !== null) {
      toReturn['searchFilters'] = 'toApiJson' in this.searchFilters ? this.searchFilters.toApiJson() : this.searchFilters;
    }
    return toReturn;
  }
}
class AuxiliaryDataRange {
  static fromProto(proto) {
    let m = new AuxiliaryDataRange();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.beginRange !== 'undefined') {
      toReturn['beginRange'] = this.beginRange;
    }
    if (typeof this.endRange !== 'undefined') {
      toReturn['endRange'] = this.endRange;
    }
    return toReturn;
  }
}
class AuxiliaryDataSearchFilter {
  static fromProto(proto) {
    let m = new AuxiliaryDataSearchFilter();
    m = Object.assign(m, proto);
    if (proto.operation) {
      m.operation = AuxiliaryDataSearchOperation.fromProto(proto.operation);
    }
    if (proto.filterRange) {
      m.filterRange = AuxiliaryDataRange.fromProto(proto.filterRange);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fieldId !== 'undefined') {
      toReturn['fieldId'] = this.fieldId;
    }
    if (typeof this.operation !== 'undefined' && this.operation !== null) {
      toReturn['operation'] = 'toApiJson' in this.operation ? this.operation.toApiJson() : this.operation;
    }
    if (typeof this.stringFilterValue !== 'undefined') {
      toReturn['stringFilterValue'] = this.stringFilterValue;
    }
    if (typeof this.filterRange !== 'undefined' && this.filterRange !== null) {
      toReturn['filterRange'] = 'toApiJson' in this.filterRange ? this.filterRange.toApiJson() : this.filterRange;
    }
    return toReturn;
  }
}
class AuxiliaryDataSearchOperation {
  static fromProto(proto) {
    let m = new AuxiliaryDataSearchOperation();
    m = Object.assign(m, proto);
    if (proto.stringOperation) {
      m.stringOperation = enumStringToValue(AuxiliaryDataSearchStringOperation, proto.stringOperation);
    }
    if (proto.dateOperation) {
      m.dateOperation = enumStringToValue(AuxiliaryDataSearchDateOperation, proto.dateOperation);
    }
    if (proto.integerOperation) {
      m.integerOperation = enumStringToValue(AuxiliaryDataSearchIntegerOperation, proto.integerOperation);
    }
    if (proto.dropdownOperation) {
      m.dropdownOperation = enumStringToValue(AuxiliaryDataSearchStringOperation, proto.dropdownOperation);
    }
    if (proto.currencyOperation) {
      m.currencyOperation = enumStringToValue(AuxiliaryDataSearchIntegerOperation, proto.currencyOperation);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.stringOperation !== 'undefined') {
      toReturn['stringOperation'] = this.stringOperation;
    }
    if (typeof this.dateOperation !== 'undefined') {
      toReturn['dateOperation'] = this.dateOperation;
    }
    if (typeof this.integerOperation !== 'undefined') {
      toReturn['integerOperation'] = this.integerOperation;
    }
    if (typeof this.dropdownOperation !== 'undefined') {
      toReturn['dropdownOperation'] = this.dropdownOperation;
    }
    if (typeof this.currencyOperation !== 'undefined') {
      toReturn['currencyOperation'] = this.currencyOperation;
    }
    return toReturn;
  }
}
class BulkUpdateRequest {
  static fromProto(proto) {
    let m = new BulkUpdateRequest();
    m = Object.assign(m, proto);
    if (proto.updateOperations) {
      m.updateOperations = proto.updateOperations.map(UpdateOperation.fromProto);
    }
    if (proto.ifUnmodifiedSince) {
      m.ifUnmodifiedSince = new Date(proto.ifUnmodifiedSince);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.updateOperations !== 'undefined' && this.updateOperations !== null) {
      toReturn['updateOperations'] = 'toApiJson' in this.updateOperations ? this.updateOperations.toApiJson() : this.updateOperations;
    }
    if (typeof this.ifUnmodifiedSince !== 'undefined' && this.ifUnmodifiedSince !== null) {
      toReturn['ifUnmodifiedSince'] = 'toApiJson' in this.ifUnmodifiedSince ? this.ifUnmodifiedSince.toApiJson() : this.ifUnmodifiedSince;
    }
    return toReturn;
  }
}
class GetMultiBusinessDataFromPlaceIdResponseBusinessesEntry {
  static fromProto(proto) {
    let m = new GetMultiBusinessDataFromPlaceIdResponseBusinessesEntry();
    m = Object.assign(m, proto);
    if (proto.value) {
      m.value = GetBusinessDataFromPlaceIdResponse.fromProto(proto.value);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    if (typeof this.value !== 'undefined' && this.value !== null) {
      toReturn['value'] = 'toApiJson' in this.value ? this.value.toApiJson() : this.value;
    }
    return toReturn;
  }
}
class Candidate {
  static fromProto(proto) {
    let m = new Candidate();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.googlePlaceId !== 'undefined') {
      toReturn['googlePlaceId'] = this.googlePlaceId;
    }
    return toReturn;
  }
}
class CategoryData {
  static fromProto(proto) {
    let m = new CategoryData();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.externalId !== 'undefined') {
      toReturn['externalId'] = this.externalId;
    }
    return toReturn;
  }
}
class CategoryMigrationData {
  static fromProto(proto) {
    let m = new CategoryMigrationData();
    m = Object.assign(m, proto);
    if (proto.napData) {
      m.napData = NAPData.fromProto(proto.napData);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.reviewed !== 'undefined') {
      toReturn['reviewed'] = this.reviewed;
    }
    if (typeof this.currentTaxonomies !== 'undefined') {
      toReturn['currentTaxonomies'] = this.currentTaxonomies;
    }
    if (typeof this.currentCategories !== 'undefined') {
      toReturn['currentCategories'] = this.currentCategories;
    }
    if (typeof this.newCategories !== 'undefined') {
      toReturn['newCategories'] = this.newCategories;
    }
    if (typeof this.napData !== 'undefined' && this.napData !== null) {
      toReturn['napData'] = 'toApiJson' in this.napData ? this.napData.toApiJson() : this.napData;
    }
    return toReturn;
  }
}
class Circular {
  static fromProto(proto) {
    let m = new Circular();
    m = Object.assign(m, proto);
    if (proto.center) {
      m.center = LocationPoint.fromProto(proto.center);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.center !== 'undefined' && this.center !== null) {
      toReturn['center'] = 'toApiJson' in this.center ? this.center.toApiJson() : this.center;
    }
    if (typeof this.radius !== 'undefined') {
      toReturn['radius'] = this.radius;
    }
    return toReturn;
  }
}
class ClaimStatus {
  static fromProto(proto) {
    let m = new ClaimStatus();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.gbpIsClaimed !== 'undefined') {
      toReturn['gbpIsClaimed'] = this.gbpIsClaimed;
    }
    return toReturn;
  }
}
class Constraint {
  static fromProto(proto) {
    let m = new Constraint();
    m = Object.assign(m, proto);
    if (proto.foreignKey) {
      m.foreignKey = ForeignKey.fromProto(proto.foreignKey);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.foreignKey !== 'undefined' && this.foreignKey !== null) {
      toReturn['foreignKey'] = 'toApiJson' in this.foreignKey ? this.foreignKey.toApiJson() : this.foreignKey;
    }
    return toReturn;
  }
}
class ConstraintsModify {
  static fromProto(proto) {
    let m = new ConstraintsModify();
    m = Object.assign(m, proto);
    if (proto.addConstraints) {
      m.addConstraints = proto.addConstraints.map(Constraint.fromProto);
    }
    if (proto.removeConstraints) {
      m.removeConstraints = proto.removeConstraints.map(Constraint.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.addConstraints !== 'undefined' && this.addConstraints !== null) {
      toReturn['addConstraints'] = 'toApiJson' in this.addConstraints ? this.addConstraints.toApiJson() : this.addConstraints;
    }
    if (typeof this.removeConstraints !== 'undefined' && this.removeConstraints !== null) {
      toReturn['removeConstraints'] = 'toApiJson' in this.removeConstraints ? this.removeConstraints.toApiJson() : this.removeConstraints;
    }
    return toReturn;
  }
}
class ContactDetails {
  static fromProto(proto) {
    let m = new ContactDetails();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    return toReturn;
  }
}
class ContactDetailsForListDuplicates {
  static fromProto(proto) {
    let m = new ContactDetailsForListDuplicates();
    m = Object.assign(m, proto);
    if (proto.contactDetails) {
      m.contactDetails = ContactDetails.fromProto(proto.contactDetails);
    }
    if (proto.location) {
      m.location = AccountGroupLocation.fromProto(proto.location);
    }
    if (proto.criteriaMatchType) {
      m.criteriaMatchType = enumStringToValue(ContactDetailsForListDuplicatesCriteriaMatchType, proto.criteriaMatchType);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.contactDetails !== 'undefined' && this.contactDetails !== null) {
      toReturn['contactDetails'] = 'toApiJson' in this.contactDetails ? this.contactDetails.toApiJson() : this.contactDetails;
    }
    if (typeof this.location !== 'undefined' && this.location !== null) {
      toReturn['location'] = 'toApiJson' in this.location ? this.location.toApiJson() : this.location;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.countryCode !== 'undefined') {
      toReturn['countryCode'] = this.countryCode;
    }
    if (typeof this.criteriaMatchType !== 'undefined') {
      toReturn['criteriaMatchType'] = this.criteriaMatchType;
    }
    return toReturn;
  }
}
class CreateAccountGroupRequest {
  static fromProto(proto) {
    let m = new CreateAccountGroupRequest();
    m = Object.assign(m, proto);
    if (proto.accountGroupNap) {
      m.accountGroupNap = AccountGroupLocation.fromProto(proto.accountGroupNap);
    }
    if (proto.updateOperations) {
      m.updateOperations = proto.updateOperations.map(UpdateOperation.fromProto);
    }
    if (proto.createOperations) {
      m.createOperations = proto.createOperations.map(CreateOperation.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupNap !== 'undefined' && this.accountGroupNap !== null) {
      toReturn['accountGroupNap'] = 'toApiJson' in this.accountGroupNap ? this.accountGroupNap.toApiJson() : this.accountGroupNap;
    }
    if (typeof this.socialProfileGroupId !== 'undefined') {
      toReturn['socialProfileGroupId'] = this.socialProfileGroupId;
    }
    if (typeof this.updateOperations !== 'undefined' && this.updateOperations !== null) {
      toReturn['updateOperations'] = 'toApiJson' in this.updateOperations ? this.updateOperations.toApiJson() : this.updateOperations;
    }
    if (typeof this.createOperations !== 'undefined' && this.createOperations !== null) {
      toReturn['createOperations'] = 'toApiJson' in this.createOperations ? this.createOperations.toApiJson() : this.createOperations;
    }
    return toReturn;
  }
}
class CreateAccountGroupResponse {
  static fromProto(proto) {
    let m = new CreateAccountGroupResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class CreateCompetitors {
  static fromProto(proto) {
    let m = new CreateCompetitors();
    m = Object.assign(m, proto);
    if (proto.location) {
      m.location = proto.location.map(Location.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.location !== 'undefined' && this.location !== null) {
      toReturn['location'] = 'toApiJson' in this.location ? this.location.toApiJson() : this.location;
    }
    return toReturn;
  }
}
class CreateOperation {
  static fromProto(proto) {
    let m = new CreateOperation();
    m = Object.assign(m, proto);
    if (proto.activateAccounts) {
      m.activateAccounts = ActivateAccounts.fromProto(proto.activateAccounts);
    }
    if (proto.createCompetitors) {
      m.createCompetitors = CreateCompetitors.fromProto(proto.createCompetitors);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.activateAccounts !== 'undefined' && this.activateAccounts !== null) {
      toReturn['activateAccounts'] = 'toApiJson' in this.activateAccounts ? this.activateAccounts.toApiJson() : this.activateAccounts;
    }
    if (typeof this.createCompetitors !== 'undefined' && this.createCompetitors !== null) {
      toReturn['createCompetitors'] = 'toApiJson' in this.createCompetitors ? this.createCompetitors.toApiJson() : this.createCompetitors;
    }
    return toReturn;
  }
}
class LookupRequestCreatedDateFilter {
  static fromProto(proto) {
    let m = new LookupRequestCreatedDateFilter();
    m = Object.assign(m, proto);
    if (proto.beginRange) {
      m.beginRange = new Date(proto.beginRange);
    }
    if (proto.endRange) {
      m.endRange = new Date(proto.endRange);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.beginRange !== 'undefined' && this.beginRange !== null) {
      toReturn['beginRange'] = 'toApiJson' in this.beginRange ? this.beginRange.toApiJson() : this.beginRange;
    }
    if (typeof this.endRange !== 'undefined' && this.endRange !== null) {
      toReturn['endRange'] = 'toApiJson' in this.endRange ? this.endRange.toApiJson() : this.endRange;
    }
    return toReturn;
  }
}
class CustomField {
  static fromProto(proto) {
    let m = new CustomField();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.name !== 'undefined') {
      toReturn['name'] = this.name;
    }
    if (typeof this.value !== 'undefined') {
      toReturn['value'] = this.value;
    }
    return toReturn;
  }
}
class DeleteAccountGroupRequest {
  static fromProto(proto) {
    let m = new DeleteAccountGroupRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class FetchProspectDataRequest {
  static fromProto(proto) {
    let m = new FetchProspectDataRequest();
    m = Object.assign(m, proto);
    if (proto.prospects) {
      m.prospects = proto.prospects.map(ProspectIdentifier.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.prospects !== 'undefined' && this.prospects !== null) {
      toReturn['prospects'] = 'toApiJson' in this.prospects ? this.prospects.toApiJson() : this.prospects;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class LookupRequestFilters {
  static fromProto(proto) {
    let m = new LookupRequestFilters();
    m = Object.assign(m, proto);
    if (proto.accountFilters) {
      m.accountFilters = proto.accountFilters.map(LookupRequestAccountFilter.fromProto);
    }
    if (proto.listingDistributionFilter) {
      m.listingDistributionFilter = LookupRequestListingDistributionFilter.fromProto(proto.listingDistributionFilter);
    }
    if (proto.createdDateFilter) {
      m.createdDateFilter = LookupRequestCreatedDateFilter.fromProto(proto.createdDateFilter);
    }
    if (proto.listingSyncProFilter) {
      m.listingSyncProFilter = LookupRequestListingSyncProFilter.fromProto(proto.listingSyncProFilter);
    }
    if (proto.trialFilter) {
      m.trialFilter = LookupRequestTrialFilter.fromProto(proto.trialFilter);
    }
    if (proto.presenceFilter) {
      m.presenceFilter = LookupRequestPresenceFilter.fromProto(proto.presenceFilter);
    }
    if (proto.locationFilter) {
      m.locationFilter = LookupRequestLocationFilter.fromProto(proto.locationFilter);
    }
    if (proto.snapshotFilter) {
      m.snapshotFilter = LookupRequestSnapshotFilter.fromProto(proto.snapshotFilter);
    }
    if (proto.statusFilter) {
      m.statusFilter = LookupRequestStatusFilter.fromProto(proto.statusFilter);
    }
    if (proto.customFields) {
      m.customFields = proto.customFields.map(CustomField.fromProto);
    }
    if (proto.accountFilterOperator) {
      m.accountFilterOperator = enumStringToValue(LookupRequestAccountFilterOperator, proto.accountFilterOperator);
    }
    if (proto.lifecycleStage) {
      m.lifecycleStage = proto.lifecycleStage.map(v => enumStringToValue(LifecycleStage, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketIds !== 'undefined') {
      toReturn['marketIds'] = this.marketIds;
    }
    if (typeof this.salesPersonId !== 'undefined') {
      toReturn['salesPersonId'] = this.salesPersonId;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.tags !== 'undefined') {
      toReturn['tags'] = this.tags;
    }
    if (typeof this.accountFilters !== 'undefined' && this.accountFilters !== null) {
      toReturn['accountFilters'] = 'toApiJson' in this.accountFilters ? this.accountFilters.toApiJson() : this.accountFilters;
    }
    if (typeof this.listingDistributionFilter !== 'undefined' && this.listingDistributionFilter !== null) {
      toReturn['listingDistributionFilter'] = 'toApiJson' in this.listingDistributionFilter ? this.listingDistributionFilter.toApiJson() : this.listingDistributionFilter;
    }
    if (typeof this.createdDateFilter !== 'undefined' && this.createdDateFilter !== null) {
      toReturn['createdDateFilter'] = 'toApiJson' in this.createdDateFilter ? this.createdDateFilter.toApiJson() : this.createdDateFilter;
    }
    if (typeof this.listingSyncProFilter !== 'undefined' && this.listingSyncProFilter !== null) {
      toReturn['listingSyncProFilter'] = 'toApiJson' in this.listingSyncProFilter ? this.listingSyncProFilter.toApiJson() : this.listingSyncProFilter;
    }
    if (typeof this.trialFilter !== 'undefined' && this.trialFilter !== null) {
      toReturn['trialFilter'] = 'toApiJson' in this.trialFilter ? this.trialFilter.toApiJson() : this.trialFilter;
    }
    if (typeof this.taxonomyIds !== 'undefined') {
      toReturn['taxonomyIds'] = this.taxonomyIds;
    }
    if (typeof this.presenceFilter !== 'undefined' && this.presenceFilter !== null) {
      toReturn['presenceFilter'] = 'toApiJson' in this.presenceFilter ? this.presenceFilter.toApiJson() : this.presenceFilter;
    }
    if (typeof this.locationFilter !== 'undefined' && this.locationFilter !== null) {
      toReturn['locationFilter'] = 'toApiJson' in this.locationFilter ? this.locationFilter.toApiJson() : this.locationFilter;
    }
    if (typeof this.salesforceId !== 'undefined') {
      toReturn['salesforceId'] = this.salesforceId;
    }
    if (typeof this.snapshotFilter !== 'undefined' && this.snapshotFilter !== null) {
      toReturn['snapshotFilter'] = 'toApiJson' in this.snapshotFilter ? this.snapshotFilter.toApiJson() : this.snapshotFilter;
    }
    if (typeof this.statusFilter !== 'undefined' && this.statusFilter !== null) {
      toReturn['statusFilter'] = 'toApiJson' in this.statusFilter ? this.statusFilter.toApiJson() : this.statusFilter;
    }
    if (typeof this.accountGroupIds !== 'undefined') {
      toReturn['accountGroupIds'] = this.accountGroupIds;
    }
    if (typeof this.includeDeleted !== 'undefined') {
      toReturn['includeDeleted'] = this.includeDeleted;
    }
    if (typeof this.customFields !== 'undefined' && this.customFields !== null) {
      toReturn['customFields'] = 'toApiJson' in this.customFields ? this.customFields.toApiJson() : this.customFields;
    }
    if (typeof this.accountFilterOperator !== 'undefined') {
      toReturn['accountFilterOperator'] = this.accountFilterOperator;
    }
    if (typeof this.lifecycleStage !== 'undefined') {
      toReturn['lifecycleStage'] = this.lifecycleStage;
    }
    if (typeof this.platformCrmCompanyId !== 'undefined') {
      toReturn['platformCrmCompanyId'] = this.platformCrmCompanyId;
    }
    return toReturn;
  }
}
class ForeignKey {
  static fromProto(proto) {
    let m = new ForeignKey();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.kind !== 'undefined') {
      toReturn['kind'] = this.kind;
    }
    if (typeof this.key !== 'undefined') {
      toReturn['key'] = this.key;
    }
    return toReturn;
  }
}
class Geo {
  static fromProto(proto) {
    let m = new Geo();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.latitude !== 'undefined') {
      toReturn['latitude'] = this.latitude;
    }
    if (typeof this.longitude !== 'undefined') {
      toReturn['longitude'] = this.longitude;
    }
    return toReturn;
  }
}
class GetAccountsToReviewByPartnerIdRequest {
  static fromProto(proto) {
    let m = new GetAccountsToReviewByPartnerIdRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetAccountsToReviewByPartnerIdResponse {
  static fromProto(proto) {
    let m = new GetAccountsToReviewByPartnerIdResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.totalAccountsToReview !== 'undefined') {
      toReturn['totalAccountsToReview'] = this.totalAccountsToReview;
    }
    return toReturn;
  }
}
class GetBusinessDataByNapDataRequest {
  static fromProto(proto) {
    let m = new GetBusinessDataByNapDataRequest();
    m = Object.assign(m, proto);
    if (proto.napData) {
      m.napData = NAPData.fromProto(proto.napData);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.napData !== 'undefined' && this.napData !== null) {
      toReturn['napData'] = 'toApiJson' in this.napData ? this.napData.toApiJson() : this.napData;
    }
    return toReturn;
  }
}
class GetBusinessDataByNapDataResponse {
  static fromProto(proto) {
    let m = new GetBusinessDataByNapDataResponse();
    m = Object.assign(m, proto);
    if (proto.categories) {
      m.categories = proto.categories.map(CategoryData.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.categories !== 'undefined' && this.categories !== null) {
      toReturn['categories'] = 'toApiJson' in this.categories ? this.categories.toApiJson() : this.categories;
    }
    return toReturn;
  }
}
class GetBusinessDataFromPlaceIdRequest {
  static fromProto(proto) {
    let m = new GetBusinessDataFromPlaceIdRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.placeId !== 'undefined') {
      toReturn['placeId'] = this.placeId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketIds !== 'undefined') {
      toReturn['marketIds'] = this.marketIds;
    }
    return toReturn;
  }
}
class GetBusinessDataFromPlaceIdResponse {
  static fromProto(proto) {
    let m = new GetBusinessDataFromPlaceIdResponse();
    m = Object.assign(m, proto);
    if (proto.googleIdentifiers) {
      m.googleIdentifiers = GetBusinessDataFromPlaceIdResponseGoogleIdentifiers.fromProto(proto.googleIdentifiers);
    }
    if (proto.napData) {
      m.napData = NAPData.fromProto(proto.napData);
    }
    if (proto.hoursOfOperation) {
      m.hoursOfOperation = HoursOfOperation.fromProto(proto.hoursOfOperation);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.googleIdentifiers !== 'undefined' && this.googleIdentifiers !== null) {
      toReturn['googleIdentifiers'] = 'toApiJson' in this.googleIdentifiers ? this.googleIdentifiers.toApiJson() : this.googleIdentifiers;
    }
    if (typeof this.napData !== 'undefined' && this.napData !== null) {
      toReturn['napData'] = 'toApiJson' in this.napData ? this.napData.toApiJson() : this.napData;
    }
    if (typeof this.taxonomyId !== 'undefined') {
      toReturn['taxonomyId'] = this.taxonomyId;
    }
    if (typeof this.hoursOfOperation !== 'undefined' && this.hoursOfOperation !== null) {
      toReturn['hoursOfOperation'] = 'toApiJson' in this.hoursOfOperation ? this.hoursOfOperation.toApiJson() : this.hoursOfOperation;
    }
    return toReturn;
  }
}
class GetBusinessDataFromTextSearchRequest {
  static fromProto(proto) {
    let m = new GetBusinessDataFromTextSearchRequest();
    m = Object.assign(m, proto);
    if (proto.circular) {
      m.circular = Circular.fromProto(proto.circular);
    }
    if (proto.point) {
      m.point = Point.fromProto(proto.point);
    }
    if (proto.rectangular) {
      m.rectangular = Rectangular.fromProto(proto.rectangular);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.inputQuery !== 'undefined') {
      toReturn['inputQuery'] = this.inputQuery;
    }
    if (typeof this.circular !== 'undefined' && this.circular !== null) {
      toReturn['circular'] = 'toApiJson' in this.circular ? this.circular.toApiJson() : this.circular;
    }
    if (typeof this.point !== 'undefined' && this.point !== null) {
      toReturn['point'] = 'toApiJson' in this.point ? this.point.toApiJson() : this.point;
    }
    if (typeof this.rectangular !== 'undefined' && this.rectangular !== null) {
      toReturn['rectangular'] = 'toApiJson' in this.rectangular ? this.rectangular.toApiJson() : this.rectangular;
    }
    return toReturn;
  }
}
class GetBusinessDataFromTextSearchResponse {
  static fromProto(proto) {
    let m = new GetBusinessDataFromTextSearchResponse();
    m = Object.assign(m, proto);
    if (proto.candidates) {
      m.candidates = proto.candidates.map(Candidate.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.candidates !== 'undefined' && this.candidates !== null) {
      toReturn['candidates'] = 'toApiJson' in this.candidates ? this.candidates.toApiJson() : this.candidates;
    }
    return toReturn;
  }
}
class GetMultiBusinessDataFromPlaceIdRequest {
  static fromProto(proto) {
    let m = new GetMultiBusinessDataFromPlaceIdRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.placeIds !== 'undefined') {
      toReturn['placeIds'] = this.placeIds;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketIds !== 'undefined') {
      toReturn['marketIds'] = this.marketIds;
    }
    return toReturn;
  }
}
class GetMultiBusinessDataFromPlaceIdResponse {
  static fromProto(proto) {
    let m = new GetMultiBusinessDataFromPlaceIdResponse();
    m = Object.assign(m, proto);
    if (proto.businesses) {
      m.businesses = Object.keys(proto.businesses).reduce((obj, k) => {
        obj[k] = GetBusinessDataFromPlaceIdResponse.fromProto(proto.businesses[k]);
        return obj;
      }, {});
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businesses !== 'undefined' && this.businesses !== null) {
      toReturn['businesses'] = 'toApiJson' in this.businesses ? this.businesses.toApiJson() : this.businesses;
    }
    return toReturn;
  }
}
class GetMultiRequest {
  static fromProto(proto) {
    let m = new GetMultiRequest();
    m = Object.assign(m, proto);
    if (proto.projectionFilter) {
      m.projectionFilter = ProjectionFilter.fromProto(proto.projectionFilter);
    }
    if (proto.readFilter) {
      m.readFilter = ReadFilter.fromProto(proto.readFilter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupIds !== 'undefined') {
      toReturn['accountGroupIds'] = this.accountGroupIds;
    }
    if (typeof this.projectionFilter !== 'undefined' && this.projectionFilter !== null) {
      toReturn['projectionFilter'] = 'toApiJson' in this.projectionFilter ? this.projectionFilter.toApiJson() : this.projectionFilter;
    }
    if (typeof this.readFilter !== 'undefined' && this.readFilter !== null) {
      toReturn['readFilter'] = 'toApiJson' in this.readFilter ? this.readFilter.toApiJson() : this.readFilter;
    }
    return toReturn;
  }
}
class GetMultiResponse {
  static fromProto(proto) {
    let m = new GetMultiResponse();
    m = Object.assign(m, proto);
    if (proto.accountGroups) {
      m.accountGroups = proto.accountGroups.map(GetMultiResponseAccountGroupContainer.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroups !== 'undefined' && this.accountGroups !== null) {
      toReturn['accountGroups'] = 'toApiJson' in this.accountGroups ? this.accountGroups.toApiJson() : this.accountGroups;
    }
    return toReturn;
  }
}
class GetProspectDataRequest {
  static fromProto(proto) {
    let m = new GetProspectDataRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.placeId !== 'undefined') {
      toReturn['placeId'] = this.placeId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetProspectDataResponse {
  static fromProto(proto) {
    let m = new GetProspectDataResponse();
    m = Object.assign(m, proto);
    if (proto.prospectData) {
      m.prospectData = ProspectData.fromProto(proto.prospectData);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.placeId !== 'undefined') {
      toReturn['placeId'] = this.placeId;
    }
    if (typeof this.prospectData !== 'undefined' && this.prospectData !== null) {
      toReturn['prospectData'] = 'toApiJson' in this.prospectData ? this.prospectData.toApiJson() : this.prospectData;
    }
    return toReturn;
  }
}
class GetPublishedPartnerRequest {
  static fromProto(proto) {
    let m = new GetPublishedPartnerRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class GetPublishedPartnerResponse {
  static fromProto(proto) {
    let m = new GetPublishedPartnerResponse();
    m = Object.assign(m, proto);
    if (proto.publishStarted) {
      m.publishStarted = new Date(proto.publishStarted);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.lastPublishedBy !== 'undefined') {
      toReturn['lastPublishedBy'] = this.lastPublishedBy;
    }
    if (typeof this.publishStarted !== 'undefined' && this.publishStarted !== null) {
      toReturn['publishStarted'] = 'toApiJson' in this.publishStarted ? this.publishStarted.toApiJson() : this.publishStarted;
    }
    return toReturn;
  }
}
class GetWebSearchRequest {
  static fromProto(proto) {
    let m = new GetWebSearchRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class GetWebSearchResponse {
  static fromProto(proto) {
    let m = new GetWebSearchResponse();
    m = Object.assign(m, proto);
    if (proto.addressInfo) {
      m.addressInfo = WebSearchAddressDetails.fromProto(proto.addressInfo);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.title !== 'undefined') {
      toReturn['title'] = this.title;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.addressInfo !== 'undefined' && this.addressInfo !== null) {
      toReturn['addressInfo'] = 'toApiJson' in this.addressInfo ? this.addressInfo.toApiJson() : this.addressInfo;
    }
    if (typeof this.url !== 'undefined') {
      toReturn['url'] = this.url;
    }
    if (typeof this.phone !== 'undefined') {
      toReturn['phone'] = this.phone;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    if (typeof this.placeId !== 'undefined') {
      toReturn['placeId'] = this.placeId;
    }
    if (typeof this.checkUrl !== 'undefined') {
      toReturn['checkUrl'] = this.checkUrl;
    }
    return toReturn;
  }
}
class GetBusinessDataFromPlaceIdResponseGoogleIdentifiers {
  static fromProto(proto) {
    let m = new GetBusinessDataFromPlaceIdResponseGoogleIdentifiers();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.googlePlaceId !== 'undefined') {
      toReturn['googlePlaceId'] = this.googlePlaceId;
    }
    if (typeof this.googleCustomerId !== 'undefined') {
      toReturn['googleCustomerId'] = this.googleCustomerId;
    }
    return toReturn;
  }
}
class GooglePlace {
  static fromProto(proto) {
    let m = new GooglePlace();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.placeId !== 'undefined') {
      toReturn['placeId'] = this.placeId;
    }
    if (typeof this.placeName !== 'undefined') {
      toReturn['placeName'] = this.placeName;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    return toReturn;
  }
}
class HealthCareProfessionalInformation {
  static fromProto(proto) {
    let m = new HealthCareProfessionalInformation();
    m = Object.assign(m, proto);
    if (proto.dateOfBirth) {
      m.dateOfBirth = new Date(proto.dateOfBirth);
    }
    if (proto.gender) {
      m.gender = enumStringToValue(HealthCareProfessionalInformationGender, proto.gender);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dateOfBirth !== 'undefined' && this.dateOfBirth !== null) {
      toReturn['dateOfBirth'] = 'toApiJson' in this.dateOfBirth ? this.dateOfBirth.toApiJson() : this.dateOfBirth;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.fellowship !== 'undefined') {
      toReturn['fellowship'] = this.fellowship;
    }
    if (typeof this.firstName !== 'undefined') {
      toReturn['firstName'] = this.firstName;
    }
    if (typeof this.gender !== 'undefined') {
      toReturn['gender'] = this.gender;
    }
    if (typeof this.initials !== 'undefined') {
      toReturn['initials'] = this.initials;
    }
    if (typeof this.insurancesAccepted !== 'undefined') {
      toReturn['insurancesAccepted'] = this.insurancesAccepted;
    }
    if (typeof this.lastName !== 'undefined') {
      toReturn['lastName'] = this.lastName;
    }
    if (typeof this.medicalLicenseNumber !== 'undefined') {
      toReturn['medicalLicenseNumber'] = this.medicalLicenseNumber;
    }
    if (typeof this.nationalProviderIdentifier !== 'undefined') {
      toReturn['nationalProviderIdentifier'] = this.nationalProviderIdentifier;
    }
    if (typeof this.office !== 'undefined') {
      toReturn['office'] = this.office;
    }
    if (typeof this.professionalCredential !== 'undefined') {
      toReturn['professionalCredential'] = this.professionalCredential;
    }
    if (typeof this.residency !== 'undefined') {
      toReturn['residency'] = this.residency;
    }
    if (typeof this.school !== 'undefined') {
      toReturn['school'] = this.school;
    }
    if (typeof this.specialty !== 'undefined') {
      toReturn['specialty'] = this.specialty;
    }
    if (typeof this.standardizedTitle !== 'undefined') {
      toReturn['standardizedTitle'] = this.standardizedTitle;
    }
    if (typeof this.stateLicense !== 'undefined') {
      toReturn['stateLicense'] = this.stateLicense;
    }
    if (typeof this.isTakingPatients !== 'undefined') {
      toReturn['isTakingPatients'] = this.isTakingPatients;
    }
    return toReturn;
  }
}
class HoursOfOperation {
  static fromProto(proto) {
    let m = new HoursOfOperation();
    m = Object.assign(m, proto);
    if (proto.hoursOfOperation) {
      m.hoursOfOperation = proto.hoursOfOperation.map(HoursOfOperationSpan.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hoursOfOperation !== 'undefined' && this.hoursOfOperation !== null) {
      toReturn['hoursOfOperation'] = 'toApiJson' in this.hoursOfOperation ? this.hoursOfOperation.toApiJson() : this.hoursOfOperation;
    }
    return toReturn;
  }
}
class InferBusinessCategoryRequest {
  static fromProto(proto) {
    let m = new InferBusinessCategoryRequest();
    m = Object.assign(m, proto);
    if (proto.napData) {
      m.napData = NAPData.fromProto(proto.napData);
    }
    if (proto.mode) {
      m.mode = enumStringToValue(InferenceRequestMode, proto.mode);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.napData !== 'undefined' && this.napData !== null) {
      toReturn['napData'] = 'toApiJson' in this.napData ? this.napData.toApiJson() : this.napData;
    }
    if (typeof this.googlePlaceId !== 'undefined') {
      toReturn['googlePlaceId'] = this.googlePlaceId;
    }
    if (typeof this.taskId !== 'undefined') {
      toReturn['taskId'] = this.taskId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.ownerId !== 'undefined') {
      toReturn['ownerId'] = this.ownerId;
    }
    if (typeof this.origin !== 'undefined') {
      toReturn['origin'] = this.origin;
    }
    if (typeof this.mode !== 'undefined') {
      toReturn['mode'] = this.mode;
    }
    if (typeof this.returnBusinessData !== 'undefined') {
      toReturn['returnBusinessData'] = this.returnBusinessData;
    }
    return toReturn;
  }
}
class InferBusinessCategoryResponse {
  static fromProto(proto) {
    let m = new InferBusinessCategoryResponse();
    m = Object.assign(m, proto);
    if (proto.taskStatus) {
      m.taskStatus = enumStringToValue(TaskStatus, proto.taskStatus);
    }
    if (proto.businessData) {
      m.businessData = NAPData.fromProto(proto.businessData);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.categories !== 'undefined') {
      toReturn['categories'] = this.categories;
    }
    if (typeof this.taskStatus !== 'undefined') {
      toReturn['taskStatus'] = this.taskStatus;
    }
    if (typeof this.taskId !== 'undefined') {
      toReturn['taskId'] = this.taskId;
    }
    if (typeof this.businessData !== 'undefined' && this.businessData !== null) {
      toReturn['businessData'] = 'toApiJson' in this.businessData ? this.businessData.toApiJson() : this.businessData;
    }
    return toReturn;
  }
}
class LegacyProductDetails {
  static fromProto(proto) {
    let m = new LegacyProductDetails();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.keyPerson !== 'undefined') {
      toReturn['keyPerson'] = this.keyPerson;
    }
    if (typeof this.shareOfVoiceService !== 'undefined') {
      toReturn['shareOfVoiceService'] = this.shareOfVoiceService;
    }
    if (typeof this.faxNumber !== 'undefined') {
      toReturn['faxNumber'] = this.faxNumber;
    }
    if (typeof this.commonName !== 'undefined') {
      toReturn['commonName'] = this.commonName;
    }
    if (typeof this.cellNumber !== 'undefined') {
      toReturn['cellNumber'] = this.cellNumber;
    }
    if (typeof this.competitor !== 'undefined') {
      toReturn['competitor'] = this.competitor;
    }
    if (typeof this.adminNotes !== 'undefined') {
      toReturn['adminNotes'] = this.adminNotes;
    }
    if (typeof this.seoCategory !== 'undefined') {
      toReturn['seoCategory'] = this.seoCategory;
    }
    if (typeof this.email !== 'undefined') {
      toReturn['email'] = this.email;
    }
    if (typeof this.place !== 'undefined') {
      toReturn['place'] = this.place;
    }
    if (typeof this.tagline !== 'undefined') {
      toReturn['tagline'] = this.tagline;
    }
    if (typeof this.subscribedToCampaigns !== 'undefined') {
      toReturn['subscribedToCampaigns'] = this.subscribedToCampaigns;
    }
    return toReturn;
  }
}
class ListAccountsRequest {
  static fromProto(proto) {
    let m = new ListAccountsRequest();
    m = Object.assign(m, proto);
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    return toReturn;
  }
}
class ListAccountsResponse {
  static fromProto(proto) {
    let m = new ListAccountsResponse();
    m = Object.assign(m, proto);
    if (proto.accounts) {
      m.accounts = proto.accounts.map(Account.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accounts !== 'undefined' && this.accounts !== null) {
      toReturn['accounts'] = 'toApiJson' in this.accounts ? this.accounts.toApiJson() : this.accounts;
    }
    return toReturn;
  }
}
class ListAllPotentialDuplicatesRequest {
  static fromProto(proto) {
    let m = new ListAllPotentialDuplicatesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class ListAllPotentialDuplicatesResponse {
  static fromProto(proto) {
    let m = new ListAllPotentialDuplicatesResponse();
    m = Object.assign(m, proto);
    if (proto.potentialDuplicates) {
      m.potentialDuplicates = proto.potentialDuplicates.map(ListAllPotentialDuplicatesResponsePotentialDuplicates.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.potentialDuplicates !== 'undefined' && this.potentialDuplicates !== null) {
      toReturn['potentialDuplicates'] = 'toApiJson' in this.potentialDuplicates ? this.potentialDuplicates.toApiJson() : this.potentialDuplicates;
    }
    return toReturn;
  }
}
class ListOptionsForFieldRequest {
  static fromProto(proto) {
    let m = new ListOptionsForFieldRequest();
    m = Object.assign(m, proto);
    if (proto.field) {
      m.field = enumStringToValue(AggregationSupportedFields, proto.field);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.field !== 'undefined') {
      toReturn['field'] = this.field;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class ListOptionsForFieldResponse {
  static fromProto(proto) {
    let m = new ListOptionsForFieldResponse();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.values !== 'undefined') {
      toReturn['values'] = this.values;
    }
    return toReturn;
  }
}
class ListPotentialDuplicatesRequest {
  static fromProto(proto) {
    let m = new ListPotentialDuplicatesRequest();
    m = Object.assign(m, proto);
    if (proto.location) {
      m.location = AccountGroupLocation.fromProto(proto.location);
    }
    if (proto.contactDetails) {
      m.contactDetails = ContactDetails.fromProto(proto.contactDetails);
    }
    if (proto.contactDetailsForListDuplicates) {
      m.contactDetailsForListDuplicates = ContactDetailsForListDuplicates.fromProto(proto.contactDetailsForListDuplicates);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.location !== 'undefined' && this.location !== null) {
      toReturn['location'] = 'toApiJson' in this.location ? this.location.toApiJson() : this.location;
    }
    if (typeof this.contactDetails !== 'undefined' && this.contactDetails !== null) {
      toReturn['contactDetails'] = 'toApiJson' in this.contactDetails ? this.contactDetails.toApiJson() : this.contactDetails;
    }
    if (typeof this.contactDetailsForListDuplicates !== 'undefined' && this.contactDetailsForListDuplicates !== null) {
      toReturn['contactDetailsForListDuplicates'] = 'toApiJson' in this.contactDetailsForListDuplicates ? this.contactDetailsForListDuplicates.toApiJson() : this.contactDetailsForListDuplicates;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.marketId !== 'undefined') {
      toReturn['marketId'] = this.marketId;
    }
    return toReturn;
  }
}
class ListPotentialDuplicatesResponse {
  static fromProto(proto) {
    let m = new ListPotentialDuplicatesResponse();
    m = Object.assign(m, proto);
    if (proto.potentialDuplicates) {
      m.potentialDuplicates = proto.potentialDuplicates.map(ListPotentialDuplicatesResponsePotentialDuplicate.fromProto);
    }
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.potentialDuplicates !== 'undefined' && this.potentialDuplicates !== null) {
      toReturn['potentialDuplicates'] = 'toApiJson' in this.potentialDuplicates ? this.potentialDuplicates.toApiJson() : this.potentialDuplicates;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class ListRequest {
  static fromProto(proto) {
    let m = new ListRequest();
    m = Object.assign(m, proto);
    if (proto.projectionFilter) {
      m.projectionFilter = ProjectionFilter.fromProto(proto.projectionFilter);
    }
    if (proto.filters) {
      m.filters = ListRequestFilters.fromProto(proto.filters);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.readFilter) {
      m.readFilter = ReadFilter.fromProto(proto.readFilter);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.projectionFilter !== 'undefined' && this.projectionFilter !== null) {
      toReturn['projectionFilter'] = 'toApiJson' in this.projectionFilter ? this.projectionFilter.toApiJson() : this.projectionFilter;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.readFilter !== 'undefined' && this.readFilter !== null) {
      toReturn['readFilter'] = 'toApiJson' in this.readFilter ? this.readFilter.toApiJson() : this.readFilter;
    }
    return toReturn;
  }
}
class ListRequestFilters {
  static fromProto(proto) {
    let m = new ListRequestFilters();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class ListingDistributionDetails {
  static fromProto(proto) {
    let m = new ListingDistributionDetails();
    m = Object.assign(m, proto);
    if (proto.fromDate) {
      m.fromDate = new Date(proto.fromDate);
    }
    if (proto.thruDate) {
      m.thruDate = new Date(proto.thruDate);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.orderId !== 'undefined') {
      toReturn['orderId'] = this.orderId;
    }
    if (typeof this.purchaseId !== 'undefined') {
      toReturn['purchaseId'] = this.purchaseId;
    }
    if (typeof this.fromDate !== 'undefined' && this.fromDate !== null) {
      toReturn['fromDate'] = 'toApiJson' in this.fromDate ? this.fromDate.toApiJson() : this.fromDate;
    }
    if (typeof this.thruDate !== 'undefined' && this.thruDate !== null) {
      toReturn['thruDate'] = 'toApiJson' in this.thruDate ? this.thruDate.toApiJson() : this.thruDate;
    }
    if (typeof this.autoRenew !== 'undefined') {
      toReturn['autoRenew'] = this.autoRenew;
    }
    return toReturn;
  }
}
class LookupRequestListingDistributionFilter {
  static fromProto(proto) {
    let m = new LookupRequestListingDistributionFilter();
    m = Object.assign(m, proto);
    if (proto.expiresInDays) {
      m.expiresInDays = parseInt(proto.expiresInDays, 10);
    }
    if (proto.expiredInDays) {
      m.expiredInDays = parseInt(proto.expiredInDays, 10);
    }
    if (proto.renewsInDays) {
      m.renewsInDays = parseInt(proto.renewsInDays, 10);
    }
    if (proto.autoRenew) {
      m.autoRenew = enumStringToValue(LookupRequestListingDistributionFilterAutoRenew, proto.autoRenew);
    }
    if (proto.activationStatus) {
      m.activationStatus = enumStringToValue(LookupRequestListingDistributionFilterActivationStatus, proto.activationStatus);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.active !== 'undefined') {
      toReturn['active'] = this.active;
    }
    if (typeof this.inactive !== 'undefined') {
      toReturn['inactive'] = this.inactive;
    }
    if (typeof this.expiresInDays !== 'undefined') {
      toReturn['expiresInDays'] = this.expiresInDays;
    }
    if (typeof this.expiredInDays !== 'undefined') {
      toReturn['expiredInDays'] = this.expiredInDays;
    }
    if (typeof this.renewsInDays !== 'undefined') {
      toReturn['renewsInDays'] = this.renewsInDays;
    }
    if (typeof this.autoRenew !== 'undefined') {
      toReturn['autoRenew'] = this.autoRenew;
    }
    if (typeof this.activationStatus !== 'undefined') {
      toReturn['activationStatus'] = this.activationStatus;
    }
    return toReturn;
  }
}
class ListingSyncPro {
  static fromProto(proto) {
    let m = new ListingSyncPro();
    m = Object.assign(m, proto);
    if (proto.purchaseDate) {
      m.purchaseDate = new Date(proto.purchaseDate);
    }
    if (proto.billingFrequency) {
      m.billingFrequency = enumStringToValue(ListingSyncProBillingFrequency, proto.billingFrequency);
    }
    if (proto.expiryDate) {
      m.expiryDate = new Date(proto.expiryDate);
    }
    if (proto.serviceProvider) {
      m.serviceProvider = enumStringToValue(ListingSyncProServiceProviders, proto.serviceProvider);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.purchaseDate !== 'undefined' && this.purchaseDate !== null) {
      toReturn['purchaseDate'] = 'toApiJson' in this.purchaseDate ? this.purchaseDate.toApiJson() : this.purchaseDate;
    }
    if (typeof this.billingFrequency !== 'undefined') {
      toReturn['billingFrequency'] = this.billingFrequency;
    }
    if (typeof this.expiryDate !== 'undefined' && this.expiryDate !== null) {
      toReturn['expiryDate'] = 'toApiJson' in this.expiryDate ? this.expiryDate.toApiJson() : this.expiryDate;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.discountFlag !== 'undefined') {
      toReturn['discountFlag'] = this.discountFlag;
    }
    if (typeof this.serviceProvider !== 'undefined') {
      toReturn['serviceProvider'] = this.serviceProvider;
    }
    return toReturn;
  }
}
class LookupRequestListingSyncProFilter {
  static fromProto(proto) {
    let m = new LookupRequestListingSyncProFilter();
    m = Object.assign(m, proto);
    if (proto.expiresInDays) {
      m.expiresInDays = parseInt(proto.expiresInDays, 10);
    }
    if (proto.expiredInDays) {
      m.expiredInDays = parseInt(proto.expiredInDays, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.active !== 'undefined') {
      toReturn['active'] = this.active;
    }
    if (typeof this.autoRenew !== 'undefined') {
      toReturn['autoRenew'] = this.autoRenew;
    }
    if (typeof this.autoRenewDisabled !== 'undefined') {
      toReturn['autoRenewDisabled'] = this.autoRenewDisabled;
    }
    if (typeof this.inactive !== 'undefined') {
      toReturn['inactive'] = this.inactive;
    }
    if (typeof this.expired !== 'undefined') {
      toReturn['expired'] = this.expired;
    }
    if (typeof this.expiresInDays !== 'undefined') {
      toReturn['expiresInDays'] = this.expiresInDays;
    }
    if (typeof this.expiredInDays !== 'undefined') {
      toReturn['expiredInDays'] = this.expiredInDays;
    }
    return toReturn;
  }
}
class LookupRequestLocationFilter {
  static fromProto(proto) {
    let m = new LookupRequestLocationFilter();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    return toReturn;
  }
}
class LocationPoint {
  static fromProto(proto) {
    let m = new LocationPoint();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.latitude !== 'undefined') {
      toReturn['latitude'] = this.latitude;
    }
    if (typeof this.longitude !== 'undefined') {
      toReturn['longitude'] = this.longitude;
    }
    return toReturn;
  }
}
class LookupRequest {
  static fromProto(proto) {
    let m = new LookupRequest();
    m = Object.assign(m, proto);
    if (proto.projectionFilter) {
      m.projectionFilter = ProjectionFilter.fromProto(proto.projectionFilter);
    }
    if (proto.filters) {
      m.filters = LookupRequestFilters.fromProto(proto.filters);
    }
    if (proto.pageSize) {
      m.pageSize = parseInt(proto.pageSize, 10);
    }
    if (proto.sortOptions) {
      m.sortOptions = SortOptions.fromProto(proto.sortOptions);
    }
    if (proto.searchOptions) {
      m.searchOptions = LookupRequestSearchOptions.fromProto(proto.searchOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.projectionFilter !== 'undefined' && this.projectionFilter !== null) {
      toReturn['projectionFilter'] = 'toApiJson' in this.projectionFilter ? this.projectionFilter.toApiJson() : this.projectionFilter;
    }
    if (typeof this.filters !== 'undefined' && this.filters !== null) {
      toReturn['filters'] = 'toApiJson' in this.filters ? this.filters.toApiJson() : this.filters;
    }
    if (typeof this.cursor !== 'undefined') {
      toReturn['cursor'] = this.cursor;
    }
    if (typeof this.pageSize !== 'undefined') {
      toReturn['pageSize'] = this.pageSize;
    }
    if (typeof this.sortOptions !== 'undefined' && this.sortOptions !== null) {
      toReturn['sortOptions'] = 'toApiJson' in this.sortOptions ? this.sortOptions.toApiJson() : this.sortOptions;
    }
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.searchOptions !== 'undefined' && this.searchOptions !== null) {
      toReturn['searchOptions'] = 'toApiJson' in this.searchOptions ? this.searchOptions.toApiJson() : this.searchOptions;
    }
    return toReturn;
  }
}
class MarketingInfo {
  static fromProto(proto) {
    let m = new MarketingInfo();
    m = Object.assign(m, proto);
    if (proto.marketingClassification) {
      m.marketingClassification = enumStringToValue(MarketingClassification, proto.marketingClassification);
    }
    if (proto.lifecycleStage) {
      m.lifecycleStage = enumStringToValue(LifecycleStage, proto.lifecycleStage);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.conversionPoint !== 'undefined') {
      toReturn['conversionPoint'] = this.conversionPoint;
    }
    if (typeof this.marketingClassification !== 'undefined') {
      toReturn['marketingClassification'] = this.marketingClassification;
    }
    if (typeof this.lifecycleStage !== 'undefined') {
      toReturn['lifecycleStage'] = this.lifecycleStage;
    }
    return toReturn;
  }
}
class NAPData {
  static fromProto(proto) {
    let m = new NAPData();
    m = Object.assign(m, proto);
    if (proto.location) {
      m.location = Geo.fromProto(proto.location);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.companyName !== 'undefined') {
      toReturn['companyName'] = this.companyName;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.address2 !== 'undefined') {
      toReturn['address2'] = this.address2;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.zip !== 'undefined') {
      toReturn['zip'] = this.zip;
    }
    if (typeof this.workNumber !== 'undefined') {
      toReturn['workNumber'] = this.workNumber;
    }
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    if (typeof this.location !== 'undefined' && this.location !== null) {
      toReturn['location'] = 'toApiJson' in this.location ? this.location.toApiJson() : this.location;
    }
    return toReturn;
  }
}
class NAPWData {
  static fromProto(proto) {
    let m = new NAPWData();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.state !== 'undefined') {
      toReturn['state'] = this.state;
    }
    if (typeof this.country !== 'undefined') {
      toReturn['country'] = this.country;
    }
    if (typeof this.zip !== 'undefined') {
      toReturn['zip'] = this.zip;
    }
    if (typeof this.phone !== 'undefined') {
      toReturn['phone'] = this.phone;
    }
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    return toReturn;
  }
}
class OnBoardingStrategy {
  static fromProto(proto) {
    let m = new OnBoardingStrategy();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.goal !== 'undefined') {
      toReturn['goal'] = this.goal;
    }
    if (typeof this.earlyWins !== 'undefined') {
      toReturn['earlyWins'] = this.earlyWins;
    }
    if (typeof this.priorities !== 'undefined') {
      toReturn['priorities'] = this.priorities;
    }
    return toReturn;
  }
}
class PagedResponse {
  static fromProto(proto) {
    let m = new PagedResponse();
    m = Object.assign(m, proto);
    if (proto.accountGroups) {
      m.accountGroups = proto.accountGroups.map(AccountGroup.fromProto);
    }
    if (proto.totalResults) {
      m.totalResults = parseInt(proto.totalResults, 10);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroups !== 'undefined' && this.accountGroups !== null) {
      toReturn['accountGroups'] = 'toApiJson' in this.accountGroups ? this.accountGroups.toApiJson() : this.accountGroups;
    }
    if (typeof this.nextCursor !== 'undefined') {
      toReturn['nextCursor'] = this.nextCursor;
    }
    if (typeof this.hasMore !== 'undefined') {
      toReturn['hasMore'] = this.hasMore;
    }
    if (typeof this.totalResults !== 'undefined') {
      toReturn['totalResults'] = this.totalResults;
    }
    return toReturn;
  }
}
class Point {
  static fromProto(proto) {
    let m = new Point();
    m = Object.assign(m, proto);
    if (proto.dot) {
      m.dot = LocationPoint.fromProto(proto.dot);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dot !== 'undefined' && this.dot !== null) {
      toReturn['dot'] = 'toApiJson' in this.dot ? this.dot.toApiJson() : this.dot;
    }
    return toReturn;
  }
}
class ListPotentialDuplicatesResponsePotentialDuplicate {
  static fromProto(proto) {
    let m = new ListPotentialDuplicatesResponsePotentialDuplicate();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.score !== 'undefined') {
      toReturn['score'] = this.score;
    }
    return toReturn;
  }
}
class ListAllPotentialDuplicatesResponsePotentialDuplicates {
  static fromProto(proto) {
    let m = new ListAllPotentialDuplicatesResponsePotentialDuplicates();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupIds !== 'undefined') {
      toReturn['accountGroupIds'] = this.accountGroupIds;
    }
    if (typeof this.phoneNumber !== 'undefined') {
      toReturn['phoneNumber'] = this.phoneNumber;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.customerId !== 'undefined') {
      toReturn['customerId'] = this.customerId;
    }
    return toReturn;
  }
}
class PreMigrateBusinessCategoryRequest {
  static fromProto(proto) {
    let m = new PreMigrateBusinessCategoryRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    return toReturn;
  }
}
class LookupRequestPresenceFilter {
  static fromProto(proto) {
    let m = new LookupRequestPresenceFilter();
    m = Object.assign(m, proto);
    if (proto.facebook) {
      m.facebook = enumStringToValue(LookupRequestPresence, proto.facebook);
    }
    if (proto.foursquare) {
      m.foursquare = enumStringToValue(LookupRequestPresence, proto.foursquare);
    }
    if (proto.googleplus) {
      m.googleplus = enumStringToValue(LookupRequestPresence, proto.googleplus);
    }
    if (proto.linkedin) {
      m.linkedin = enumStringToValue(LookupRequestPresence, proto.linkedin);
    }
    if (proto.twitter) {
      m.twitter = enumStringToValue(LookupRequestPresence, proto.twitter);
    }
    if (proto.pinterest) {
      m.pinterest = enumStringToValue(LookupRequestPresence, proto.pinterest);
    }
    if (proto.instagram) {
      m.instagram = enumStringToValue(LookupRequestPresence, proto.instagram);
    }
    if (proto.youtube) {
      m.youtube = enumStringToValue(LookupRequestPresence, proto.youtube);
    }
    if (proto.website) {
      m.website = enumStringToValue(LookupRequestPresence, proto.website);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.facebook !== 'undefined') {
      toReturn['facebook'] = this.facebook;
    }
    if (typeof this.foursquare !== 'undefined') {
      toReturn['foursquare'] = this.foursquare;
    }
    if (typeof this.googleplus !== 'undefined') {
      toReturn['googleplus'] = this.googleplus;
    }
    if (typeof this.linkedin !== 'undefined') {
      toReturn['linkedin'] = this.linkedin;
    }
    if (typeof this.twitter !== 'undefined') {
      toReturn['twitter'] = this.twitter;
    }
    if (typeof this.pinterest !== 'undefined') {
      toReturn['pinterest'] = this.pinterest;
    }
    if (typeof this.instagram !== 'undefined') {
      toReturn['instagram'] = this.instagram;
    }
    if (typeof this.youtube !== 'undefined') {
      toReturn['youtube'] = this.youtube;
    }
    if (typeof this.website !== 'undefined') {
      toReturn['website'] = this.website;
    }
    return toReturn;
  }
}
class ProjectionFilter {
  static fromProto(proto) {
    let m = new ProjectionFilter();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accounts !== 'undefined') {
      toReturn['accounts'] = this.accounts;
    }
    if (typeof this.listingDistribution !== 'undefined') {
      toReturn['listingDistribution'] = this.listingDistribution;
    }
    if (typeof this.listingSyncPro !== 'undefined') {
      toReturn['listingSyncPro'] = this.listingSyncPro;
    }
    if (typeof this.associations !== 'undefined') {
      toReturn['associations'] = this.associations;
    }
    if (typeof this.accountGroupExternalIdentifiers !== 'undefined') {
      toReturn['accountGroupExternalIdentifiers'] = this.accountGroupExternalIdentifiers;
    }
    if (typeof this.socialUrls !== 'undefined') {
      toReturn['socialUrls'] = this.socialUrls;
    }
    if (typeof this.hoursOfOperation !== 'undefined') {
      toReturn['hoursOfOperation'] = this.hoursOfOperation;
    }
    if (typeof this.contactDetails !== 'undefined') {
      toReturn['contactDetails'] = this.contactDetails;
    }
    if (typeof this.snapshotReports !== 'undefined') {
      toReturn['snapshotReports'] = this.snapshotReports;
    }
    if (typeof this.legacyProductDetails !== 'undefined') {
      toReturn['legacyProductDetails'] = this.legacyProductDetails;
    }
    if (typeof this.richData !== 'undefined') {
      toReturn['richData'] = this.richData;
    }
    if (typeof this.status !== 'undefined') {
      toReturn['status'] = this.status;
    }
    if (typeof this.napData !== 'undefined') {
      toReturn['napData'] = this.napData;
    }
    if (typeof this.onBoardingStrategy !== 'undefined') {
      toReturn['onBoardingStrategy'] = this.onBoardingStrategy;
    }
    if (typeof this.health !== 'undefined') {
      toReturn['health'] = this.health;
    }
    if (typeof this.constraints !== 'undefined') {
      toReturn['constraints'] = this.constraints;
    }
    if (typeof this.additionalCompanyInfo !== 'undefined') {
      toReturn['additionalCompanyInfo'] = this.additionalCompanyInfo;
    }
    if (typeof this.marketingInfo !== 'undefined') {
      toReturn['marketingInfo'] = this.marketingInfo;
    }
    return toReturn;
  }
}
class ProspectData {
  static fromProto(proto) {
    let m = new ProspectData();
    m = Object.assign(m, proto);
    if (proto.gbpClaimStatus) {
      m.gbpClaimStatus = ClaimStatus.fromProto(proto.gbpClaimStatus);
    }
    if (proto.websiteStatus) {
      m.websiteStatus = WebsiteStatus.fromProto(proto.websiteStatus);
    }
    if (proto.napwData) {
      m.napwData = NAPWData.fromProto(proto.napwData);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.gbpClaimStatus !== 'undefined' && this.gbpClaimStatus !== null) {
      toReturn['gbpClaimStatus'] = 'toApiJson' in this.gbpClaimStatus ? this.gbpClaimStatus.toApiJson() : this.gbpClaimStatus;
    }
    if (typeof this.websiteStatus !== 'undefined' && this.websiteStatus !== null) {
      toReturn['websiteStatus'] = 'toApiJson' in this.websiteStatus ? this.websiteStatus.toApiJson() : this.websiteStatus;
    }
    if (typeof this.napwData !== 'undefined' && this.napwData !== null) {
      toReturn['napwData'] = 'toApiJson' in this.napwData ? this.napwData.toApiJson() : this.napwData;
    }
    return toReturn;
  }
}
class ProspectIdentifier {
  static fromProto(proto) {
    let m = new ProspectIdentifier();
    m = Object.assign(m, proto);
    if (proto.location) {
      m.location = Geo.fromProto(proto.location);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.placeId !== 'undefined') {
      toReturn['placeId'] = this.placeId;
    }
    if (typeof this.location !== 'undefined' && this.location !== null) {
      toReturn['location'] = 'toApiJson' in this.location ? this.location.toApiJson() : this.location;
    }
    return toReturn;
  }
}
class ReadFilter {
  static fromProto(proto) {
    let m = new ReadFilter();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.includeDeleted !== 'undefined') {
      toReturn['includeDeleted'] = this.includeDeleted;
    }
    return toReturn;
  }
}
class Rectangular {
  static fromProto(proto) {
    let m = new Rectangular();
    m = Object.assign(m, proto);
    if (proto.southwest) {
      m.southwest = LocationPoint.fromProto(proto.southwest);
    }
    if (proto.northeast) {
      m.northeast = LocationPoint.fromProto(proto.northeast);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.southwest !== 'undefined' && this.southwest !== null) {
      toReturn['southwest'] = 'toApiJson' in this.southwest ? this.southwest.toApiJson() : this.southwest;
    }
    if (typeof this.northeast !== 'undefined' && this.northeast !== null) {
      toReturn['northeast'] = 'toApiJson' in this.northeast ? this.northeast.toApiJson() : this.northeast;
    }
    return toReturn;
  }
}
class RichData {
  static fromProto(proto) {
    let m = new RichData();
    m = Object.assign(m, proto);
    if (proto.paymentMethods) {
      m.paymentMethods = proto.paymentMethods.map(v => enumStringToValue(RichDataPaymentMethods, v));
    }
    if (proto.customFields) {
      m.customFields = proto.customFields.map(CustomField.fromProto);
    }
    if (proto.healthCareProfessionalInformation) {
      m.healthCareProfessionalInformation = HealthCareProfessionalInformation.fromProto(proto.healthCareProfessionalInformation);
    }
    if (proto.serviceAvailability) {
      m.serviceAvailability = ServiceAvailability.fromProto(proto.serviceAvailability);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.tollFreeNumber !== 'undefined') {
      toReturn['tollFreeNumber'] = this.tollFreeNumber;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    if (typeof this.shortDescription !== 'undefined') {
      toReturn['shortDescription'] = this.shortDescription;
    }
    if (typeof this.servicesOffered !== 'undefined') {
      toReturn['servicesOffered'] = this.servicesOffered;
    }
    if (typeof this.brandsCarried !== 'undefined') {
      toReturn['brandsCarried'] = this.brandsCarried;
    }
    if (typeof this.landmark !== 'undefined') {
      toReturn['landmark'] = this.landmark;
    }
    if (typeof this.paymentMethods !== 'undefined') {
      toReturn['paymentMethods'] = this.paymentMethods;
    }
    if (typeof this.customFields !== 'undefined' && this.customFields !== null) {
      toReturn['customFields'] = 'toApiJson' in this.customFields ? this.customFields.toApiJson() : this.customFields;
    }
    if (typeof this.healthCareProfessionalInformation !== 'undefined' && this.healthCareProfessionalInformation !== null) {
      toReturn['healthCareProfessionalInformation'] = 'toApiJson' in this.healthCareProfessionalInformation ? this.healthCareProfessionalInformation.toApiJson() : this.healthCareProfessionalInformation;
    }
    if (typeof this.inferredAttributes !== 'undefined') {
      toReturn['inferredAttributes'] = this.inferredAttributes;
    }
    if (typeof this.serviceAvailability !== 'undefined' && this.serviceAvailability !== null) {
      toReturn['serviceAvailability'] = 'toApiJson' in this.serviceAvailability ? this.serviceAvailability.toApiJson() : this.serviceAvailability;
    }
    if (typeof this.faxNumber !== 'undefined') {
      toReturn['faxNumber'] = this.faxNumber;
    }
    if (typeof this.cellNumber !== 'undefined') {
      toReturn['cellNumber'] = this.cellNumber;
    }
    return toReturn;
  }
}
class SearchByAuxiliaryDataRequest {
  static fromProto(proto) {
    let m = new SearchByAuxiliaryDataRequest();
    m = Object.assign(m, proto);
    if (proto.filter) {
      m.filter = AuxiliaryDataFilter.fromProto(proto.filter);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.filter !== 'undefined' && this.filter !== null) {
      toReturn['filter'] = 'toApiJson' in this.filter ? this.filter.toApiJson() : this.filter;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class SearchByAuxiliaryDataResponse {
  static fromProto(proto) {
    let m = new SearchByAuxiliaryDataResponse();
    m = Object.assign(m, proto);
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupIds !== 'undefined') {
      toReturn['accountGroupIds'] = this.accountGroupIds;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class SearchCategoryMigrationRequest {
  static fromProto(proto) {
    let m = new SearchCategoryMigrationRequest();
    m = Object.assign(m, proto);
    if (proto.reviewStatus) {
      m.reviewStatus = enumStringToValue(SearchCategoryMigrationRequestReviewStatus, proto.reviewStatus);
    }
    if (proto.pagingOptions) {
      m.pagingOptions = PagedRequestOptions.fromProto(proto.pagingOptions);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.searchTerm !== 'undefined') {
      toReturn['searchTerm'] = this.searchTerm;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.reviewStatus !== 'undefined') {
      toReturn['reviewStatus'] = this.reviewStatus;
    }
    if (typeof this.pagingOptions !== 'undefined' && this.pagingOptions !== null) {
      toReturn['pagingOptions'] = 'toApiJson' in this.pagingOptions ? this.pagingOptions.toApiJson() : this.pagingOptions;
    }
    return toReturn;
  }
}
class SearchCategoryMigrationResponse {
  static fromProto(proto) {
    let m = new SearchCategoryMigrationResponse();
    m = Object.assign(m, proto);
    if (proto.categoryMigrations) {
      m.categoryMigrations = proto.categoryMigrations.map(CategoryMigrationData.fromProto);
    }
    if (proto.pagingMetadata) {
      m.pagingMetadata = PagedResponseMetadata.fromProto(proto.pagingMetadata);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.categoryMigrations !== 'undefined' && this.categoryMigrations !== null) {
      toReturn['categoryMigrations'] = 'toApiJson' in this.categoryMigrations ? this.categoryMigrations.toApiJson() : this.categoryMigrations;
    }
    if (typeof this.pagingMetadata !== 'undefined' && this.pagingMetadata !== null) {
      toReturn['pagingMetadata'] = 'toApiJson' in this.pagingMetadata ? this.pagingMetadata.toApiJson() : this.pagingMetadata;
    }
    return toReturn;
  }
}
class LookupRequestSearchOptions {
  static fromProto(proto) {
    let m = new LookupRequestSearchOptions();
    m = Object.assign(m, proto);
    if (proto.fields) {
      m.fields = proto.fields.map(v => enumStringToValue(SearchableField, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.fields !== 'undefined') {
      toReturn['fields'] = this.fields;
    }
    return toReturn;
  }
}
class ServiceArea {
  static fromProto(proto) {
    let m = new ServiceArea();
    m = Object.assign(m, proto);
    if (proto.businessType) {
      m.businessType = enumStringToValue(ServiceAreaBusinessType, proto.businessType);
    }
    if (proto.places) {
      m.places = proto.places.map(GooglePlace.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.businessType !== 'undefined') {
      toReturn['businessType'] = this.businessType;
    }
    if (typeof this.places !== 'undefined' && this.places !== null) {
      toReturn['places'] = 'toApiJson' in this.places ? this.places.toApiJson() : this.places;
    }
    return toReturn;
  }
}
class ServiceAvailability {
  static fromProto(proto) {
    let m = new ServiceAvailability();
    m = Object.assign(m, proto);
    if (proto.delivery) {
      m.delivery = enumStringToValue(IsAvailable, proto.delivery);
    }
    if (proto.noContactDelivery) {
      m.noContactDelivery = enumStringToValue(IsAvailable, proto.noContactDelivery);
    }
    if (proto.inStorePickup) {
      m.inStorePickup = enumStringToValue(IsAvailable, proto.inStorePickup);
    }
    if (proto.curbsidePickup) {
      m.curbsidePickup = enumStringToValue(IsAvailable, proto.curbsidePickup);
    }
    if (proto.appointmentsOnly) {
      m.appointmentsOnly = enumStringToValue(IsAvailable, proto.appointmentsOnly);
    }
    if (proto.ecommerceOnly) {
      m.ecommerceOnly = enumStringToValue(IsAvailable, proto.ecommerceOnly);
    }
    if (proto.closedStatus) {
      m.closedStatus = enumStringToValue(ClosedStatus, proto.closedStatus);
    }
    if (proto.closedStatusDate) {
      m.closedStatusDate = new Date(proto.closedStatusDate);
    }
    if (proto.reopeningDate) {
      m.reopeningDate = new Date(proto.reopeningDate);
    }
    if (proto.servesDineIn) {
      m.servesDineIn = enumStringToValue(IsAvailable, proto.servesDineIn);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.delivery !== 'undefined') {
      toReturn['delivery'] = this.delivery;
    }
    if (typeof this.noContactDelivery !== 'undefined') {
      toReturn['noContactDelivery'] = this.noContactDelivery;
    }
    if (typeof this.inStorePickup !== 'undefined') {
      toReturn['inStorePickup'] = this.inStorePickup;
    }
    if (typeof this.curbsidePickup !== 'undefined') {
      toReturn['curbsidePickup'] = this.curbsidePickup;
    }
    if (typeof this.appointmentsOnly !== 'undefined') {
      toReturn['appointmentsOnly'] = this.appointmentsOnly;
    }
    if (typeof this.ecommerceOnly !== 'undefined') {
      toReturn['ecommerceOnly'] = this.ecommerceOnly;
    }
    if (typeof this.closedStatus !== 'undefined') {
      toReturn['closedStatus'] = this.closedStatus;
    }
    if (typeof this.closedStatusDate !== 'undefined' && this.closedStatusDate !== null) {
      toReturn['closedStatusDate'] = 'toApiJson' in this.closedStatusDate ? this.closedStatusDate.toApiJson() : this.closedStatusDate;
    }
    if (typeof this.reopeningDate !== 'undefined' && this.reopeningDate !== null) {
      toReturn['reopeningDate'] = 'toApiJson' in this.reopeningDate ? this.reopeningDate.toApiJson() : this.reopeningDate;
    }
    if (typeof this.servesDineIn !== 'undefined') {
      toReturn['servesDineIn'] = this.servesDineIn;
    }
    return toReturn;
  }
}
class SnapshotsSnapshot {
  static fromProto(proto) {
    let m = new SnapshotsSnapshot();
    m = Object.assign(m, proto);
    if (proto.created) {
      m.created = new Date(proto.created);
    }
    if (proto.expiry) {
      m.expiry = new Date(proto.expiry);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshotId !== 'undefined') {
      toReturn['snapshotId'] = this.snapshotId;
    }
    if (typeof this.created !== 'undefined' && this.created !== null) {
      toReturn['created'] = 'toApiJson' in this.created ? this.created.toApiJson() : this.created;
    }
    if (typeof this.expiry !== 'undefined' && this.expiry !== null) {
      toReturn['expiry'] = 'toApiJson' in this.expiry ? this.expiry.toApiJson() : this.expiry;
    }
    return toReturn;
  }
}
class LookupRequestSnapshotFilter {
  static fromProto(proto) {
    let m = new LookupRequestSnapshotFilter();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.active !== 'undefined') {
      toReturn['active'] = this.active;
    }
    if (typeof this.expired !== 'undefined') {
      toReturn['expired'] = this.expired;
    }
    if (typeof this.noSnapshotsCreated !== 'undefined') {
      toReturn['noSnapshotsCreated'] = this.noSnapshotsCreated;
    }
    return toReturn;
  }
}
class Snapshots {
  static fromProto(proto) {
    let m = new Snapshots();
    m = Object.assign(m, proto);
    if (proto.snapshots) {
      m.snapshots = proto.snapshots.map(SnapshotsSnapshot.fromProto);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.snapshots !== 'undefined' && this.snapshots !== null) {
      toReturn['snapshots'] = 'toApiJson' in this.snapshots ? this.snapshots.toApiJson() : this.snapshots;
    }
    return toReturn;
  }
}
class SocialURLs {
  static fromProto(proto) {
    let m = new SocialURLs();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.googleplusUrl !== 'undefined') {
      toReturn['googleplusUrl'] = this.googleplusUrl;
    }
    if (typeof this.linkedinUrl !== 'undefined') {
      toReturn['linkedinUrl'] = this.linkedinUrl;
    }
    if (typeof this.foursquareUrl !== 'undefined') {
      toReturn['foursquareUrl'] = this.foursquareUrl;
    }
    if (typeof this.twitterUrl !== 'undefined') {
      toReturn['twitterUrl'] = this.twitterUrl;
    }
    if (typeof this.facebookUrl !== 'undefined') {
      toReturn['facebookUrl'] = this.facebookUrl;
    }
    if (typeof this.rssUrl !== 'undefined') {
      toReturn['rssUrl'] = this.rssUrl;
    }
    if (typeof this.youtubeUrl !== 'undefined') {
      toReturn['youtubeUrl'] = this.youtubeUrl;
    }
    if (typeof this.instagramUrl !== 'undefined') {
      toReturn['instagramUrl'] = this.instagramUrl;
    }
    if (typeof this.pinterestUrl !== 'undefined') {
      toReturn['pinterestUrl'] = this.pinterestUrl;
    }
    return toReturn;
  }
}
class SortOptions {
  static fromProto(proto) {
    let m = new SortOptions();
    m = Object.assign(m, proto);
    if (proto.direction) {
      m.direction = enumStringToValue(SortDirection, proto.direction);
    }
    if (proto.field) {
      m.field = enumStringToValue(SortField, proto.field);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.direction !== 'undefined') {
      toReturn['direction'] = this.direction;
    }
    if (typeof this.field !== 'undefined') {
      toReturn['field'] = this.field;
    }
    return toReturn;
  }
}
class HoursOfOperationSpan {
  static fromProto(proto) {
    let m = new HoursOfOperationSpan();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.dayOfWeek !== 'undefined') {
      toReturn['dayOfWeek'] = this.dayOfWeek;
    }
    if (typeof this.opens !== 'undefined') {
      toReturn['opens'] = this.opens;
    }
    if (typeof this.closes !== 'undefined') {
      toReturn['closes'] = this.closes;
    }
    if (typeof this.description !== 'undefined') {
      toReturn['description'] = this.description;
    }
    return toReturn;
  }
}
class Status {
  static fromProto(proto) {
    let m = new Status();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.suspended !== 'undefined') {
      toReturn['suspended'] = this.suspended;
    }
    if (typeof this.hasAlert !== 'undefined') {
      toReturn['hasAlert'] = this.hasAlert;
    }
    return toReturn;
  }
}
class LookupRequestStatusFilter {
  static fromProto(proto) {
    let m = new LookupRequestStatusFilter();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hasAlert !== 'undefined') {
      toReturn['hasAlert'] = this.hasAlert;
    }
    return toReturn;
  }
}
class LookupRequestTrialFilter {
  static fromProto(proto) {
    let m = new LookupRequestTrialFilter();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.isSuspended !== 'undefined') {
      toReturn['isSuspended'] = this.isSuspended;
    }
    return toReturn;
  }
}
class UpdateAccountWithExternalBusinessDataRequest {
  static fromProto(proto) {
    let m = new UpdateAccountWithExternalBusinessDataRequest();
    m = Object.assign(m, proto);
    if (proto.field) {
      m.field = proto.field.map(v => enumStringToValue(UpdateAccountWithExternalBusinessDataRequestFields, v));
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.marketIds !== 'undefined') {
      toReturn['marketIds'] = this.marketIds;
    }
    if (typeof this.field !== 'undefined') {
      toReturn['field'] = this.field;
    }
    return toReturn;
  }
}
class UpdateOperation {
  static fromProto(proto) {
    let m = new UpdateOperation();
    m = Object.assign(m, proto);
    if (proto.accountGroupNap) {
      m.accountGroupNap = AccountGroupLocation.fromProto(proto.accountGroupNap);
    }
    if (proto.listingSyncProto) {
      m.listingSyncProto = ListingSyncPro.fromProto(proto.listingSyncProto);
    }
    if (proto.accountGroupExternalIdentifiers) {
      m.accountGroupExternalIdentifiers = AccountGroupExternalIdentifiers.fromProto(proto.accountGroupExternalIdentifiers);
    }
    if (proto.socialUrls) {
      m.socialUrls = SocialURLs.fromProto(proto.socialUrls);
    }
    if (proto.hoursOfOperation) {
      m.hoursOfOperation = HoursOfOperation.fromProto(proto.hoursOfOperation);
    }
    if (proto.contactDetails) {
      m.contactDetails = ContactDetails.fromProto(proto.contactDetails);
    }
    if (proto.snapshots) {
      m.snapshots = Snapshots.fromProto(proto.snapshots);
    }
    if (proto.legacyProductDetails) {
      m.legacyProductDetails = LegacyProductDetails.fromProto(proto.legacyProductDetails);
    }
    if (proto.richData) {
      m.richData = RichData.fromProto(proto.richData);
    }
    if (proto.status) {
      m.status = Status.fromProto(proto.status);
    }
    if (proto.actionListAppend) {
      m.actionListAppend = ActionListAppend.fromProto(proto.actionListAppend);
    }
    if (proto.actionListModify) {
      m.actionListModify = ActionListModify.fromProto(proto.actionListModify);
    }
    if (proto.health) {
      m.health = UpdateOperationAccountGroupHealthUpdate.fromProto(proto.health);
    }
    if (proto.constraintsModify) {
      m.constraintsModify = ConstraintsModify.fromProto(proto.constraintsModify);
    }
    if (proto.additionalCompanyInfo) {
      m.additionalCompanyInfo = AdditionalCompanyInfo.fromProto(proto.additionalCompanyInfo);
    }
    if (proto.marketingInfo) {
      m.marketingInfo = MarketingInfo.fromProto(proto.marketingInfo);
    }
    if (proto.fieldMask) {
      m.fieldMask = FieldMask.fromProto(proto.fieldMask);
    }
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.accountGroupNap !== 'undefined' && this.accountGroupNap !== null) {
      toReturn['accountGroupNap'] = 'toApiJson' in this.accountGroupNap ? this.accountGroupNap.toApiJson() : this.accountGroupNap;
    }
    if (typeof this.listingSyncProto !== 'undefined' && this.listingSyncProto !== null) {
      toReturn['listingSyncProto'] = 'toApiJson' in this.listingSyncProto ? this.listingSyncProto.toApiJson() : this.listingSyncProto;
    }
    if (typeof this.accountGroupExternalIdentifiers !== 'undefined' && this.accountGroupExternalIdentifiers !== null) {
      toReturn['accountGroupExternalIdentifiers'] = 'toApiJson' in this.accountGroupExternalIdentifiers ? this.accountGroupExternalIdentifiers.toApiJson() : this.accountGroupExternalIdentifiers;
    }
    if (typeof this.socialUrls !== 'undefined' && this.socialUrls !== null) {
      toReturn['socialUrls'] = 'toApiJson' in this.socialUrls ? this.socialUrls.toApiJson() : this.socialUrls;
    }
    if (typeof this.hoursOfOperation !== 'undefined' && this.hoursOfOperation !== null) {
      toReturn['hoursOfOperation'] = 'toApiJson' in this.hoursOfOperation ? this.hoursOfOperation.toApiJson() : this.hoursOfOperation;
    }
    if (typeof this.contactDetails !== 'undefined' && this.contactDetails !== null) {
      toReturn['contactDetails'] = 'toApiJson' in this.contactDetails ? this.contactDetails.toApiJson() : this.contactDetails;
    }
    if (typeof this.snapshots !== 'undefined' && this.snapshots !== null) {
      toReturn['snapshots'] = 'toApiJson' in this.snapshots ? this.snapshots.toApiJson() : this.snapshots;
    }
    if (typeof this.legacyProductDetails !== 'undefined' && this.legacyProductDetails !== null) {
      toReturn['legacyProductDetails'] = 'toApiJson' in this.legacyProductDetails ? this.legacyProductDetails.toApiJson() : this.legacyProductDetails;
    }
    if (typeof this.richData !== 'undefined' && this.richData !== null) {
      toReturn['richData'] = 'toApiJson' in this.richData ? this.richData.toApiJson() : this.richData;
    }
    if (typeof this.status !== 'undefined' && this.status !== null) {
      toReturn['status'] = 'toApiJson' in this.status ? this.status.toApiJson() : this.status;
    }
    if (typeof this.actionListAppend !== 'undefined' && this.actionListAppend !== null) {
      toReturn['actionListAppend'] = 'toApiJson' in this.actionListAppend ? this.actionListAppend.toApiJson() : this.actionListAppend;
    }
    if (typeof this.actionListModify !== 'undefined' && this.actionListModify !== null) {
      toReturn['actionListModify'] = 'toApiJson' in this.actionListModify ? this.actionListModify.toApiJson() : this.actionListModify;
    }
    if (typeof this.health !== 'undefined' && this.health !== null) {
      toReturn['health'] = 'toApiJson' in this.health ? this.health.toApiJson() : this.health;
    }
    if (typeof this.constraintsModify !== 'undefined' && this.constraintsModify !== null) {
      toReturn['constraintsModify'] = 'toApiJson' in this.constraintsModify ? this.constraintsModify.toApiJson() : this.constraintsModify;
    }
    if (typeof this.additionalCompanyInfo !== 'undefined' && this.additionalCompanyInfo !== null) {
      toReturn['additionalCompanyInfo'] = 'toApiJson' in this.additionalCompanyInfo ? this.additionalCompanyInfo.toApiJson() : this.additionalCompanyInfo;
    }
    if (typeof this.marketingInfo !== 'undefined' && this.marketingInfo !== null) {
      toReturn['marketingInfo'] = 'toApiJson' in this.marketingInfo ? this.marketingInfo.toApiJson() : this.marketingInfo;
    }
    if (typeof this.fieldMask !== 'undefined' && this.fieldMask !== null) {
      toReturn['fieldMask'] = 'toApiJson' in this.fieldMask ? this.fieldMask.toApiJson() : this.fieldMask;
    }
    return toReturn;
  }
}
class UpdatePreMigrationCategoriesRequest {
  static fromProto(proto) {
    let m = new UpdatePreMigrationCategoriesRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.newCategories !== 'undefined') {
      toReturn['newCategories'] = this.newCategories;
    }
    return toReturn;
  }
}
class UpdatePublishedPartnersRequest {
  static fromProto(proto) {
    let m = new UpdatePublishedPartnersRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    return toReturn;
  }
}
class UpdateReviewedStatusRequest {
  static fromProto(proto) {
    let m = new UpdateReviewedStatusRequest();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.partnerId !== 'undefined') {
      toReturn['partnerId'] = this.partnerId;
    }
    if (typeof this.accountGroupId !== 'undefined') {
      toReturn['accountGroupId'] = this.accountGroupId;
    }
    if (typeof this.reviewed !== 'undefined') {
      toReturn['reviewed'] = this.reviewed;
    }
    return toReturn;
  }
}
class WebSearchAddressDetails {
  static fromProto(proto) {
    let m = new WebSearchAddressDetails();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.borough !== 'undefined') {
      toReturn['borough'] = this.borough;
    }
    if (typeof this.address !== 'undefined') {
      toReturn['address'] = this.address;
    }
    if (typeof this.city !== 'undefined') {
      toReturn['city'] = this.city;
    }
    if (typeof this.zip !== 'undefined') {
      toReturn['zip'] = this.zip;
    }
    if (typeof this.region !== 'undefined') {
      toReturn['region'] = this.region;
    }
    if (typeof this.countryCode !== 'undefined') {
      toReturn['countryCode'] = this.countryCode;
    }
    return toReturn;
  }
}
class WebsiteStatus {
  static fromProto(proto) {
    let m = new WebsiteStatus();
    m = Object.assign(m, proto);
    return m;
  }
  constructor(kwargs) {
    if (!kwargs) {
      return;
    }
    Object.assign(this, kwargs);
  }
  toApiJson() {
    const toReturn = {};
    if (typeof this.hasWebsite !== 'undefined') {
      toReturn['hasWebsite'] = this.hasWebsite;
    }
    return toReturn;
  }
}

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Objects Index.
// *********************************

const environment = (window ? window['environment'] : 'prod') ?? 'prod';
const hostMap = {
  'local': 'account-group.vendasta-local.com',
  'test': '',
  'demo': 'account-group-api-demo.apigateway.co',
  'prod': 'account-group-api-prod.apigateway.co',
  'production': 'account-group-api-prod.apigateway.co'
};
let HostService = /*#__PURE__*/(() => {
  class HostService {
    get host() {
      return hostMap[environment.toLowerCase()];
    }
    get hostWithScheme() {
      return 'https://' + this.host;
    }
  }
  HostService.ɵfac = function HostService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || HostService)();
  };
  HostService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: HostService,
    factory: HostService.ɵfac,
    providedIn: 'root'
  });
  return HostService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let AccountGroupApiService = /*#__PURE__*/(() => {
  class AccountGroupApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getMulti(r) {
      const request = r.toApiJson ? r : new GetMultiRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.AccountGroupService/GetMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiResponse.fromProto(resp)));
    }
    lookup(r) {
      const request = r.toApiJson ? r : new LookupRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.AccountGroupService/Lookup", request.toApiJson(), this.apiOptions()).pipe(map(resp => PagedResponse.fromProto(resp)));
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateAccountGroupRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.AccountGroupService/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateAccountGroupResponse.fromProto(resp)));
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeleteAccountGroupRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.AccountGroupService/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    bulkUpdate(r) {
      const request = r.toApiJson ? r : new BulkUpdateRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.AccountGroupService/BulkUpdate", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    list(r) {
      const request = r.toApiJson ? r : new ListRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.AccountGroupService/List", request.toApiJson(), this.apiOptions()).pipe(map(resp => PagedResponse.fromProto(resp)));
    }
    listPotentialDuplicates(r) {
      const request = r.toApiJson ? r : new ListPotentialDuplicatesRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.AccountGroupService/ListPotentialDuplicates", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListPotentialDuplicatesResponse.fromProto(resp)));
    }
    listAllPotentialDuplicates(r) {
      const request = r.toApiJson ? r : new ListAllPotentialDuplicatesRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.AccountGroupService/ListAllPotentialDuplicates", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAllPotentialDuplicatesResponse.fromProto(resp)));
    }
    listOptionsForField(r) {
      const request = r.toApiJson ? r : new ListOptionsForFieldRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.AccountGroupService/ListOptionsForField", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListOptionsForFieldResponse.fromProto(resp)));
    }
  }
  AccountGroupApiService.ɵfac = function AccountGroupApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AccountGroupApiService)();
  };
  AccountGroupApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AccountGroupApiService,
    factory: AccountGroupApiService.ɵfac,
    providedIn: 'root'
  });
  return AccountGroupApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let AccountValidationApiService = /*#__PURE__*/(() => {
  class AccountValidationApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    validateAddressMulti(r) {
      const request = r.toApiJson ? r : new ValidateAddressMultiRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.AccountValidationService/ValidateAddressMulti", request.toApiJson(), this.apiOptions()).pipe(map(resp => ValidateAddressMultiResponse.fromProto(resp)));
    }
  }
  AccountValidationApiService.ɵfac = function AccountValidationApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AccountValidationApiService)();
  };
  AccountValidationApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AccountValidationApiService,
    factory: AccountValidationApiService.ɵfac,
    providedIn: 'root'
  });
  return AccountValidationApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let AuxiliaryFieldDataApiService = /*#__PURE__*/(() => {
  class AuxiliaryFieldDataApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    listAuxiliaryData(r) {
      const request = r.toApiJson ? r : new ListAuxiliaryDataRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.AuxiliaryFieldData/ListAuxiliaryData", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAuxiliaryDataResponse.fromProto(resp)));
    }
    upsertAuxiliaryData(r) {
      const request = r.toApiJson ? r : new UpsertAuxiliaryDataRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.AuxiliaryFieldData/UpsertAuxiliaryData", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    searchByAuxiliaryData(r) {
      const request = r.toApiJson ? r : new SearchByAuxiliaryDataRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.AuxiliaryFieldData/SearchByAuxiliaryData", request.toApiJson(), this.apiOptions()).pipe(map(resp => SearchByAuxiliaryDataResponse.fromProto(resp)));
    }
  }
  AuxiliaryFieldDataApiService.ɵfac = function AuxiliaryFieldDataApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AuxiliaryFieldDataApiService)();
  };
  AuxiliaryFieldDataApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AuxiliaryFieldDataApiService,
    factory: AuxiliaryFieldDataApiService.ɵfac,
    providedIn: 'root'
  });
  return AuxiliaryFieldDataApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let AuxiliaryFieldSchemaApiService = /*#__PURE__*/(() => {
  class AuxiliaryFieldSchemaApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    createAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new CreateAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.AuxiliaryFieldSchema/CreateAuxiliaryDataFieldSchema", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new GetAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.AuxiliaryFieldSchema/GetAuxiliaryDataFieldSchema", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAuxiliaryDataFieldSchemaResponse.fromProto(resp)));
    }
    getMultiAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new GetMultiAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.AuxiliaryFieldSchema/GetMultiAuxiliaryDataFieldSchema", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiAuxiliaryDataFieldSchemaResponse.fromProto(resp)));
    }
    listAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new ListAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.AuxiliaryFieldSchema/ListAuxiliaryDataFieldSchema", request.toApiJson(), this.apiOptions()).pipe(map(resp => ListAuxiliaryDataFieldSchemaResponse.fromProto(resp)));
    }
    updateAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new UpdateAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.AuxiliaryFieldSchema/UpdateAuxiliaryDataFieldSchema", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    archiveAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new ArchiveAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.AuxiliaryFieldSchema/ArchiveAuxiliaryDataFieldSchema", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    unarchiveAuxiliaryDataFieldSchema(r) {
      const request = r.toApiJson ? r : new UnarchiveAuxiliaryDataFieldSchemaRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.AuxiliaryFieldSchema/UnarchiveAuxiliaryDataFieldSchema", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  AuxiliaryFieldSchemaApiService.ɵfac = function AuxiliaryFieldSchemaApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AuxiliaryFieldSchemaApiService)();
  };
  AuxiliaryFieldSchemaApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AuxiliaryFieldSchemaApiService,
    factory: AuxiliaryFieldSchemaApiService.ɵfac,
    providedIn: 'root'
  });
  return AuxiliaryFieldSchemaApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let CategoryMigrationApiService = /*#__PURE__*/(() => {
  class CategoryMigrationApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getAccountsToReviewByPartnerId(r) {
      const request = r.toApiJson ? r : new GetAccountsToReviewByPartnerIdRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.CategoryMigration/GetAccountsToReviewByPartnerId", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetAccountsToReviewByPartnerIdResponse.fromProto(resp)));
    }
    searchCategoryMigration(r) {
      const request = r.toApiJson ? r : new SearchCategoryMigrationRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.CategoryMigration/SearchCategoryMigration", request.toApiJson(), this.apiOptions()).pipe(map(resp => SearchCategoryMigrationResponse.fromProto(resp)));
    }
    updatePreMigrationCategories(r) {
      const request = r.toApiJson ? r : new UpdatePreMigrationCategoriesRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.CategoryMigration/UpdatePreMigrationCategories", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    updatePublishedPartners(r) {
      const request = r.toApiJson ? r : new UpdatePublishedPartnersRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.CategoryMigration/UpdatePublishedPartners", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getPublishedPartner(r) {
      const request = r.toApiJson ? r : new GetPublishedPartnerRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.CategoryMigration/GetPublishedPartner", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetPublishedPartnerResponse.fromProto(resp)));
    }
    updateReviewedStatus(r) {
      const request = r.toApiJson ? r : new UpdateReviewedStatusRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.CategoryMigration/UpdateReviewedStatus", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  CategoryMigrationApiService.ɵfac = function CategoryMigrationApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CategoryMigrationApiService)();
  };
  CategoryMigrationApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CategoryMigrationApiService,
    factory: CategoryMigrationApiService.ɵfac,
    providedIn: 'root'
  });
  return CategoryMigrationApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let CompetitorApiService = /*#__PURE__*/(() => {
  class CompetitorApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getCompetitors(r) {
      const request = r.toApiJson ? r : new GetCompetitorsRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.CompetitorService/GetCompetitors", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetCompetitorsResponse.fromProto(resp)));
    }
    create(r) {
      const request = r.toApiJson ? r : new CreateCompetitorRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.CompetitorService/Create", request.toApiJson(), this.apiOptions()).pipe(map(resp => CreateCompetitorResponse.fromProto(resp)));
    }
    update(r) {
      const request = r.toApiJson ? r : new UpdateCompetitorRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.CompetitorService/Update", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    delete(r) {
      const request = r.toApiJson ? r : new DeleteCompetitorRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.CompetitorService/Delete", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
  }
  CompetitorApiService.ɵfac = function CompetitorApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || CompetitorApiService)();
  };
  CompetitorApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: CompetitorApiService,
    factory: CompetitorApiService.ɵfac,
    providedIn: 'root'
  });
  return CompetitorApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let InferenceApiService = /*#__PURE__*/(() => {
  class InferenceApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getBusinessDataFromPlaceId(r) {
      const request = r.toApiJson ? r : new GetBusinessDataFromPlaceIdRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.Inference/GetBusinessDataFromPlaceId", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetBusinessDataFromPlaceIdResponse.fromProto(resp)));
    }
    getMultiBusinessDataFromPlaceId(r) {
      const request = r.toApiJson ? r : new GetMultiBusinessDataFromPlaceIdRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.Inference/GetMultiBusinessDataFromPlaceId", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetMultiBusinessDataFromPlaceIdResponse.fromProto(resp)));
    }
    getBusinessDataFromTextSearch(r) {
      const request = r.toApiJson ? r : new GetBusinessDataFromTextSearchRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.Inference/GetBusinessDataFromTextSearch", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetBusinessDataFromTextSearchResponse.fromProto(resp)));
    }
    updateAccountWithExternalBusinessData(r) {
      const request = r.toApiJson ? r : new UpdateAccountWithExternalBusinessDataRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.Inference/UpdateAccountWithExternalBusinessData", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getBusinessDataByNapData(r) {
      const request = r.toApiJson ? r : new GetBusinessDataByNapDataRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.Inference/GetBusinessDataByNapData", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetBusinessDataByNapDataResponse.fromProto(resp)));
    }
    preMigrateBusinessCategory(r) {
      const request = r.toApiJson ? r : new PreMigrateBusinessCategoryRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.Inference/PreMigrateBusinessCategory", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    inferBusinessCategory(r) {
      const request = r.toApiJson ? r : new InferBusinessCategoryRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.Inference/InferBusinessCategory", request.toApiJson(), this.apiOptions()).pipe(map(resp => InferBusinessCategoryResponse.fromProto(resp)));
    }
  }
  InferenceApiService.ɵfac = function InferenceApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || InferenceApiService)();
  };
  InferenceApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: InferenceApiService,
    factory: InferenceApiService.ɵfac,
    providedIn: 'root'
  });
  return InferenceApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let ProspectingApiService = /*#__PURE__*/(() => {
  class ProspectingApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    fetchProspectData(r) {
      const request = r.toApiJson ? r : new FetchProspectDataRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.Prospecting/FetchProspectData", request.toApiJson(), {
        ...this.apiOptions(),
        observe: 'response'
      });
    }
    getProspectData(r) {
      const request = r.toApiJson ? r : new GetProspectDataRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.Prospecting/GetProspectData", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetProspectDataResponse.fromProto(resp)));
    }
  }
  ProspectingApiService.ɵfac = function ProspectingApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ProspectingApiService)();
  };
  ProspectingApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ProspectingApiService,
    factory: ProspectingApiService.ɵfac,
    providedIn: 'root'
  });
  return ProspectingApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// API Service.
// *********************************
let SearchEngineResultApiService = /*#__PURE__*/(() => {
  class SearchEngineResultApiService {
    constructor() {
      this.hostService = inject(HostService);
      this.http = inject(HttpClient);
      this._host = this.hostService.hostWithScheme;
    }
    apiOptions() {
      return {
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
        withCredentials: true
      };
    }
    getWebSearchData(r) {
      const request = r.toApiJson ? r : new GetWebSearchRequest(r);
      return this.http.post(this._host + "/accountgroup.v1.SearchEngineResult/GetWebSearchData", request.toApiJson(), this.apiOptions()).pipe(map(resp => GetWebSearchResponse.fromProto(resp)));
    }
  }
  SearchEngineResultApiService.ɵfac = function SearchEngineResultApiService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || SearchEngineResultApiService)();
  };
  SearchEngineResultApiService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: SearchEngineResultApiService,
    factory: SearchEngineResultApiService.ɵfac,
    providedIn: 'root'
  });
  return SearchEngineResultApiService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

// *********************************
// Code generated by sdkgen
// DO NOT EDIT!.
//
// Index.
// *********************************
let AccountGroupSdkService = /*#__PURE__*/(() => {
  class AccountGroupSdkService {
    constructor(accountGroupApiService) {
      this.accountGroupApiService = accountGroupApiService;
    }
    delete(accountGroupId) {
      return this.accountGroupApiService.delete({
        accountGroupId: accountGroupId
      }).pipe(map(resp => resp.ok));
    }
    lookup(r) {
      if (r.filters) {
        r.filters.accountFilterOperator = r.filters.accountFilterOperator ?? LookupRequestAccountFilterOperator.OR;
      }
      return this.accountGroupApiService.lookup(r);
    }
    listOptionsForField(r) {
      return this.accountGroupApiService.listOptionsForField(r).pipe(map(resp => !!resp?.values ? resp.values : []));
    }
  }
  AccountGroupSdkService.ɵfac = function AccountGroupSdkService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AccountGroupSdkService)(i0.ɵɵinject(AccountGroupApiService));
  };
  AccountGroupSdkService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AccountGroupSdkService,
    factory: AccountGroupSdkService.ɵfac,
    providedIn: 'root'
  });
  return AccountGroupSdkService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ProspectingSdkService = /*#__PURE__*/(() => {
  class ProspectingSdkService {
    constructor(prospectingApiService) {
      this.prospectingApiService = prospectingApiService;
    }
    fetchProspectData(r) {
      return this.prospectingApiService.fetchProspectData(r).pipe(map(resp => resp.ok));
    }
    getProspectData(r) {
      return this.prospectingApiService.getProspectData(r);
    }
  }
  ProspectingSdkService.ɵfac = function ProspectingSdkService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || ProspectingSdkService)(i0.ɵɵinject(ProspectingApiService));
  };
  ProspectingSdkService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: ProspectingSdkService,
    factory: ProspectingSdkService.ɵfac,
    providedIn: 'root'
  });
  return ProspectingSdkService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let AuxiliaryFieldDataService = /*#__PURE__*/(() => {
  class AuxiliaryFieldDataService {
    constructor(fieldDataService) {
      this.fieldDataService = fieldDataService;
    }
    listObjectData(auxiliaryDataObjectId, pagingOptions) {
      return this.fieldDataService.listAuxiliaryData({
        auxiliaryDataObjectId,
        pagingOptions
      }).pipe(map(resp => {
        const auxiliaryObjectData = {
          jsonSchema: {},
          jsonData: {},
          pagingMetadata: resp.pagingMetadata
        };
        try {
          auxiliaryObjectData.jsonSchema = JSON.parse(resp.jsonSchema);
        } catch {
          auxiliaryObjectData.jsonSchema = {};
        }
        try {
          auxiliaryObjectData.jsonData = JSON.parse(resp.jsonData);
        } catch {
          auxiliaryObjectData.jsonData = {};
        }
        auxiliaryObjectData.pagingMetadata = resp.pagingMetadata;
        return auxiliaryObjectData;
      }));
    }
    upsertObjectData(auxiliaryDataObjectId, fieldDataUpsertOperations) {
      return this.fieldDataService.upsertAuxiliaryData({
        auxiliaryDataObjectId,
        fieldDataUpsertOperations
      });
    }
  }
  AuxiliaryFieldDataService.ɵfac = function AuxiliaryFieldDataService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || AuxiliaryFieldDataService)(i0.ɵɵinject(AuxiliaryFieldDataApiService));
  };
  AuxiliaryFieldDataService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: AuxiliaryFieldDataService,
    factory: AuxiliaryFieldDataService.ɵfac,
    providedIn: 'root'
  });
  return AuxiliaryFieldDataService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let InferenceService = /*#__PURE__*/(() => {
  class InferenceService {
    constructor(inferenceApiService) {
      this.inferenceApiService = inferenceApiService;
    }
    getBusinessDataFromPlaceId(placeId, partnerId, marketIds) {
      return this.inferenceApiService.getBusinessDataFromPlaceId({
        placeId,
        partnerId,
        marketIds
      });
    }
    getMultiBusinessDataFromPlaceId(placeIds, partnerId, marketIds) {
      return this.inferenceApiService.getMultiBusinessDataFromPlaceId({
        placeIds,
        partnerId,
        marketIds
      });
    }
    getBusinessDataByNapData(napData) {
      return this.inferenceApiService.getBusinessDataByNapData({
        napData
      });
    }
    inferBusinessCategory(req) {
      return this.inferenceApiService.inferBusinessCategory(req);
    }
  }
  InferenceService.ɵfac = function InferenceService_Factory(__ngFactoryType__) {
    return new (__ngFactoryType__ || InferenceService)(i0.ɵɵinject(InferenceApiService));
  };
  InferenceService.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
    token: InferenceService,
    factory: InferenceService.ɵfac,
    providedIn: 'root'
  });
  return InferenceService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { Access, Account, AccountGroup, AccountGroupApiService, AccountGroupExternalIdentifiers, AccountGroupHealth, AccountGroupLocation, AccountGroupSdkService, AccountValidationApiService, Accounts, ActionListAppend, ActionListModify, ActionListModifyActions, ActivateAccounts, Activation, AdditionalCompanyInfo, AddressInfo, AddressValidationResult, AggregationSupportedFields, AppKey, ArchiveAuxiliaryDataFieldSchemaRequest, Association, AuxiliaryDataFieldSchema, AuxiliaryDataFieldType, AuxiliaryDataFilter, AuxiliaryDataObjectID, AuxiliaryDataRange, AuxiliaryDataSearchDateOperation, AuxiliaryDataSearchFilter, AuxiliaryDataSearchIntegerOperation, AuxiliaryDataSearchOperation, AuxiliaryDataSearchStringOperation, AuxiliaryFieldDataApiService, AuxiliaryFieldDataService, AuxiliaryFieldSchemaApiService, BulkUpdateRequest, Candidate, CategoryData, CategoryMigrationApiService, CategoryMigrationData, Circular, ClaimStatus, ClosedStatus, Competitor, CompetitorApiService, Constraint, ConstraintsModify, ContactDetails, ContactDetailsForListDuplicates, ContactDetailsForListDuplicatesCriteriaMatchType, CreateAccountGroupRequest, CreateAccountGroupResponse, CreateAuxiliaryDataFieldSchemaRequest, CreateCompetitorRequest, CreateCompetitorResponse, CreateCompetitors, CreateOperation, CustomField, DeleteAccountGroupRequest, DeleteCompetitorRequest, DropdownOption, EstimatedAnnualRevenue, FetchProspectDataRequest, FieldDataUpsertOperation, FieldMask, FieldSchemaIdentifier, ForeignKey, Geo, GetAccountsToReviewByPartnerIdRequest, GetAccountsToReviewByPartnerIdResponse, GetAuxiliaryDataFieldSchemaRequest, GetAuxiliaryDataFieldSchemaResponse, GetBusinessDataByNapDataRequest, GetBusinessDataByNapDataResponse, GetBusinessDataFromPlaceIdRequest, GetBusinessDataFromPlaceIdResponse, GetBusinessDataFromPlaceIdResponseGoogleIdentifiers, GetBusinessDataFromTextSearchRequest, GetBusinessDataFromTextSearchResponse, GetCompetitorsRequest, GetCompetitorsResponse, GetMultiAuxiliaryDataFieldSchemaRequest, GetMultiAuxiliaryDataFieldSchemaResponse, GetMultiAuxiliaryDataRequest, GetMultiAuxiliaryDataResponse, GetMultiBusinessDataFromPlaceIdRequest, GetMultiBusinessDataFromPlaceIdResponse, GetMultiBusinessDataFromPlaceIdResponseBusinessesEntry, GetMultiRequest, GetMultiResponse, GetMultiResponseAccountGroupContainer, GetProspectDataRequest, GetProspectDataResponse, GetPublishedPartnerRequest, GetPublishedPartnerResponse, GetWebSearchRequest, GetWebSearchResponse, GooglePlace, HealthCareProfessionalInformation, HealthCareProfessionalInformationGender, HoursOfOperation, HoursOfOperationSpan, InferBusinessCategoryRequest, InferBusinessCategoryResponse, InferenceApiService, InferenceRequestMode, InferenceService, IsAvailable, LegacyProductDetails, LifecycleStage, ListAccountsRequest, ListAccountsResponse, ListAllPotentialDuplicatesRequest, ListAllPotentialDuplicatesResponse, ListAllPotentialDuplicatesResponsePotentialDuplicates, ListAuxiliaryDataFieldSchemaRequest, ListAuxiliaryDataFieldSchemaRequestFilters, ListAuxiliaryDataFieldSchemaResponse, ListAuxiliaryDataRequest, ListAuxiliaryDataResponse, ListOptionsForFieldRequest, ListOptionsForFieldResponse, ListPotentialDuplicatesRequest, ListPotentialDuplicatesResponse, ListPotentialDuplicatesResponsePotentialDuplicate, ListRequest, ListRequestFilters, ListingDistributionDetails, ListingSyncPro, ListingSyncProBillingFrequency, ListingSyncProServiceProviders, Location, LocationPoint, LookupRequest, LookupRequestAccountFilter, LookupRequestAccountFilterOperator, LookupRequestAccountStatus, LookupRequestCreatedDateFilter, LookupRequestFilters, LookupRequestListingDistributionFilter, LookupRequestListingDistributionFilterActivationStatus, LookupRequestListingDistributionFilterAutoRenew, LookupRequestListingSyncProFilter, LookupRequestLocationFilter, LookupRequestPresence, LookupRequestPresenceFilter, LookupRequestSearchOptions, LookupRequestSnapshotFilter, LookupRequestStatusFilter, LookupRequestTrialFilter, MarketingClassification, MarketingInfo, MethodMetadata, NAPData, NAPWData, OnBoardingStrategy, PagedRequestOptions, PagedResponse, PagedResponseMetadata, Point, PreMigrateBusinessCategoryRequest, ProjectionFilter, ProspectData, ProspectIdentifier, ProspectingApiService, ProspectingSdkService, ReadFilter, Rectangular, RichData, RichDataPaymentMethods, SDKMetadata, SearchByAuxiliaryDataRequest, SearchByAuxiliaryDataResponse, SearchCategoryMigrationRequest, SearchCategoryMigrationRequestReviewStatus, SearchCategoryMigrationResponse, SearchEngineResultApiService, SearchableField, ServiceArea, ServiceAreaBusinessType, ServiceAvailability, Snapshots, SnapshotsSnapshot, SocialURLs, SortDirection, SortField, SortOptions, Status, TaskStatus, UnarchiveAuxiliaryDataFieldSchemaRequest, UpdateAccountWithExternalBusinessDataRequest, UpdateAccountWithExternalBusinessDataRequestFields, UpdateAuxiliaryDataFieldSchemaRequest, UpdateCompetitorRequest, UpdateOperation, UpdateOperationAccountGroupHealthUpdate, UpdatePreMigrationCategoriesRequest, UpdatePublishedPartnersRequest, UpdateReviewedStatusRequest, UpsertAuxiliaryDataRequest, ValidateAddressMultiRequest, ValidateAddressMultiResponse, WebSearchAddressDetails, WebsiteStatus };
